export const localTranslationsWords = [
  {
    Index: '1',
    Default: 'Welcome to AGB',
    Label: 'Bienvenue chez AGB',
  },
  {
    Index: '2',
    Default:
      'Secure, convenient, and modern banking at your fingertips',
    Label: 'Une banque sûre, pratique et moderne à portée de main',
  },
  {
    Index: '3',
    Default: 'Advanced Security',
    Label: 'Sécurité renforcée',
  },
  {
    Index: '4',
    Default:
      'Your data is protected with state-of-the-art encryption',
    Label: 'Vos données sont protégées par un chiffrement de pointe',
  },
  {
    Index: '5',
    Default: 'Fast Transactions',
    Label: 'Transactions rapides',
  },
  {
    Index: '6',
    Default: 'Transfer money within seconds, anytime and anywhere',
    Label:
      "Transférez de l'argent en quelques secondes, n'importe quand et n'importe où",
  },
  { Index: '7', Default: '24/7 Support', Label: 'Assistance 24/7' },
  {
    Index: '8',
    Default: 'Our team is always available to assist you',
    Label: 'Notre équipe est toujours disponible pour vous aider',
  },
  {
    Index: '9',
    Default: 'OTP verification will be required',
    Label: 'La vérification OTP sera requise',
  },
  {
    Index: '10',
    Default: 'Selfie verification required',
    Label: 'Vérification par selfie requise',
  },
  {
    Index: '11',
    Default: 'Uploading selfie...',
    Label: 'Téléchargement du selfie...',
  },
  {
    Index: '12',
    Default: 'Selfie verification ready',
    Label: 'Vérification par selfie prête',
  },
  {
    Index: '13',
    Default: 'Verifications required',
    Label: 'Vérifications requises',
  },
  {
    Index: '14',
    Default: 'Selfie uploaded',
    Label: 'Selfie téléchargé',
  },
  {
    Index: '15',
    Default: 'OTP required',
    Label: 'OTP requis',
  },
  {
    Index: '16',
    Default: 'All verifications ready',
    Label: 'Toutes les vérifications sont prêtes',
  },
  {
    Index: '17',
    Default: 'Please input your username or phone number',
    Label:
      "Veuillez saisir votre nom d'utilisateur ou votre numéro de téléphone",
  },
  {
    Index: '18',
    Default:
      'Please scroll to the bottom to accept the terms and conditions',
    Label:
      'Veuillez faire défiler jusqu’en bas pour accepter les termes et conditions.',
  },
  {
    Index: '19',
    Default: 'Scroll down',
    Label: 'Faire défiler vers le bas',
  },
  {
    Index: '20',
    Default: 'This helps keep your account secure',
    Label: 'Cela aide à protéger votre compte',
  },
  {
    Index: '21',
    Default: 'Log In Again',
    Label: 'Se reconnecter',
  },
  {
    Index: '22',
    Default:
      'Your session has expired for security reasons. Please log in again to continue using our services.',
    Label:
      'Votre session a expiré pour des raisons de sécurité. Veuillez vous reconnecter pour continuer à utiliser nos services.',
  },
  {
    Index: '23',
    Default: 'Security Notice',
    Label: 'Avis de sécurité',
  },
  {
    Index: '24',
    Default: 'Your data is protected and remains secure.',
    Label: 'Vos données sont protégées et restent sécurisées.',
  },
  {
    Index: '25',
    Default: 'Redirecting in',
    Label: 'Redirection dans',
  },
  {
    Index: '26',
    Default: 'seconds',
    Label: 'secondes',
  },
  {
    Index: '27',
    Default: 'This helps keep your account secure',
    Label: 'Cela aide à garder votre compte sécurisé',
  },
  {
    Index: '28',
    Default: 'Session Expired',
    Label: 'Session expirée',
  },
  {
    Index: '29',
    Default:
      'Your account is active, and you can explore the various features tailored for you. We just need to verify your identity to ensure your account is fully functional',
    Label:
      'Votre compte est actif et vous pouvez explorer les différentes fonctionnalités conçues pour vous. Nous devons simplement vérifier votre identité pour nous assurer que votre compte est pleinement fonctionnel.',
  },
  {
    Index: '30',
    Default:
      'Any official document bearing your name and address, such as a utility bill, bank statement, or landline telephone bill, is required. For close relatives or roommates living together, a certified statement from the person whose name appears on the document is also required',
    Label:
      "Tout document officiel portant votre nom et votre adresse, tel qu'une facture de services publics, un relevé bancaire ou une facture de téléphone fixe, est requis. Pour les proches ou colocataires vivant ensemble, une attestation certifiée de la personne dont le nom apparaît sur le document est également requise.",
  },
  {
    Index: '31',
    Default: 'View and update your identification details',
    Label: "Consultez et mettez à jour vos pièces d'identité",
  },
  {
    Index: '32',
    Default: 'Update your residence information',
    Label: 'Mettez à jour vos informations de résidence',
  },
  {
    Index: '33',
    Default: 'Basic Information',
    Label: 'Informations de base',
  },
  {
    Index: '34',
    Default: 'Full Name',
    Label: 'Nom complet',
  },
  {
    Index: '35',
    Default: 'Gender',
    Label: 'Genre',
  },
  {
    Index: '36',
    Default: 'Date of Birth',
    Label: 'Date de naissance',
  },
  {
    Index: '37',
    Default: 'Marital Status',
    Label: 'État civil',
  },
  {
    Index: '38',
    Default: 'Spouse Name',
    Label: 'Nom du conjoint',
  },
  {
    Index: '39',
    Default: 'Contact Information',
    Label: 'Coordonnées',
  },
  {
    Index: '40',
    Default: 'Family Information',
    Label: 'Informations familiales',
  },
  {
    Index: '41',
    Default: "Father's First Name",
    Label: 'Prénom du père',
  },
  {
    Index: '42',
    Default: "Father's Last Name",
    Label: 'Nom du père',
  },
  {
    Index: '43',
    Default: "Mother's First Name",
    Label: 'Prénom de la mère',
  },
  {
    Index: '44',
    Default: "Mother's Last Name",
    Label: 'Nom de la mère',
  },
  {
    Index: '45',
    Default: 'Address Information',
    Label: 'Adresse',
  },
  {
    Index: '46',
    Default: 'Address Line 1',
    Label: 'Adresse ligne 1',
  },
  {
    Index: '47',
    Default: 'Address Line 2',
    Label: 'Adresse ligne 2',
  },
  {
    Index: '48',
    Default: 'Postal Code / PO Box',
    Label: 'Boîte postale',
  },
  {
    Index: '49',
    Default: 'City',
    Label: 'Ville',
  },
  {
    Index: '50',
    Default: 'Country',
    Label: 'Pays',
  },
  {
    Index: '51',
    Default: 'Identity Documents',
    Label: "Pièces d'identité",
  },
  {
    Index: '52',
    Default: 'Identification Information',
    Label: "Pièces d'identité",
  },
  {
    Index: '53',
    Default: 'Proof of Residence',
    Label: 'Justificatif de domicile',
  },
  {
    Index: '54',
    Default: 'Proof of residence',
    Label: 'Justificatif de domicile',
  },
  {
    Index: '55',
    Default: 'ID Information',
    Label: "Informations d'identité",
  },
  {
    Index: '56',
    Default: 'Documents',
    Label: 'Documents',
  },
  {
    Index: '57',
    Default: 'Upload document',
    Label: 'Télécharger un document',
  },
  {
    Index: '58',
    Default: 'Supporting documents',
    Label: 'Documents justificatifs',
  },
  {
    Index: '59',
    Default: 'Supporting Documents',
    Label: 'Documents justificatifs',
  },
  {
    Index: '60',
    Default: 'Not provided',
    Label: 'Non renseigné',
  },
  {
    Index: '61',
    Default: 'Save changes',
    Label: 'Enregistrer les modifications',
  },
  {
    Index: '62',
    Default: 'Close',
    Label: 'Fermer',
  },
  {
    Index: '63',
    Default: 'Password',
    Label: 'Mot de passe',
  },
  {
    Index: '64',
    Default:
      "It's a good idea to use a strong password that you don't use elsewhere",
    Label:
      "Il est recommandé d'utiliser un mot de passe robuste que vous n'utilisez pas ailleurs.",
  },
  {
    Index: '65',
    Default: 'PIN Number',
    Label: 'Code PIN',
  },
  {
    Index: '66',
    Default:
      'Please provide a set of 6 digits security code for validation purposes',
    Label:
      'Veuillez définir un code de sécurité à 6 chiffres pour vos validations.',
  },
  {
    Index: '67',
    Default: 'Reset PIN number',
    Label: 'Réinitialiser le code PIN',
  },
  {
    Index: '68',
    Default:
      'A verification code will be sent to your default phone number',
    Label:
      'Un code de vérification sera envoyé à votre numéro de téléphone par défaut.',
  },
  {
    Index: '69',
    Default: 'Change password',
    Label: 'Modifier le mot de passe',
  },
  {
    Index: '70',
    Default: 'Change PIN',
    Label: 'Modifier le code PIN',
  },
  {
    Index: '71',
    Default: 'Email us',
    Label: 'Envoyez-nous un e-mail',
  },
  {
    Index: '72',
    Default: 'Send an email on support@africagoldenbank.com',
    Label: 'Envoyez un e-mail à support@africagoldenbank.com',
  },
  {
    Index: '73',
    Default: 'Call us locally',
    Label: 'Appelez-nous localement',
  },
  {
    Index: '74',
    Default: 'Use (237) 692 93 19 15 for local calls',
    Label: 'Composez le (237) 692 93 19 15 pour les appels locaux',
  },
  {
    Index: '75',
    Default: 'Call us internationally',
    Label: "Appelez-nous à l'international",
  },
  {
    Index: '76',
    Default: 'Use (237) 692 93 19 15 for international calls',
    Label: 'Composez le (237) 692 93 19 15 pour les appels internationaux',
  },
  {
    Index: '77',
    Default: 'Language',
    Label: 'Langue',
  },
  {
    Index: '78',
    Default: 'Change',
    Label: 'Changer',
  },
  {
    Index: '79',
    Default: 'Loading',
    Label: 'Chargement',
  },
  {
    Index: '80',
    Default: 'Recent Transactions',
    Label: 'Transactions récentes',
  },
  {
    Index: '81',
    Default: 'See all',
    Label: 'Voir tout',
  },
  {
    Index: '82',
    Default: 'My Accounts',
    Label: 'Mes comptes',
  },
  {
    Index: '83',
    Default: 'All Accounts',
    Label: 'Tous les comptes',
  },
  {
    Index: '84',
    Default: 'Quick Links',
    Label: 'Accès rapides',
  },
  {
    Index: '85',
    Default: 'Quick pay',
    Label: 'Paiement rapide',
  },
  {
    Index: '86',
    Default: 'Quick Pay',
    Label: 'Paiement rapide',
  },
  {
    Index: '87',
    Default: 'Get paid',
    Label: 'Recevoir un paiement',
  },
  {
    Index: '88',
    Default: 'Get Paid',
    Label: 'Recevoir un paiement',
  },
  {
    Index: '89',
    Default: 'Select an Account',
    Label: 'Sélectionner un compte',
  },
  {
    Index: '90',
    Default: 'Select a user',
    Label: 'Sélectionner un utilisateur',
  },
  {
    Index: '91',
    Default: 'Enter the amount here',
    Label: 'Entrez le montant ici',
  },
  {
    Index: '92',
    Default: 'Data Not Found',
    Label: 'Aucune donnée trouvée',
  },
  {
    Index: '93',
    Default: 'You don’t have any beneficiaries yet',
    Label: "Vous n'avez pas encore de bénéficiaires",
  },
  {
    Index: '94',
    Default: 'New',
    Label: 'Nouveau',
  },
  {
    Index: '95',
    Default: 'Proceed',
    Label: 'Continuer',
  },
  {
    Index: '96',
    Default: 'Continue',
    Label: 'Continuer',
  },
  {
    Index: '97',
    Default: 'Submit',
    Label: 'Soumettre',
  },
  {
    Index: '98',
    Default: 'Cancel',
    Label: 'Annuler',
  },
  {
    Index: '99',
    Default: 'Confirm',
    Label: 'Confirmer',
  },
  {
    Index: '100',
    Default: 'Back',
    Label: 'Retour',
  },
  {
    Index: '101',
    Default: 'Next',
    Label: 'Suivant',
  },
  {
    Index: '102',
    Default: 'Update now',
    Label: 'Mettre à jour maintenant',
  },
  {
    Index: '103',
    Default: 'Account Statement',
    Label: 'Relevé de compte',
  },
  {
    Index: '104',
    Default: 'Transaction history for the selected period',
    Label: 'Historique des transactions pour la période sélectionnée',
  },
  {
    Index: '105',
    Default: 'Total Credit',
    Label: 'Crédit total',
  },
  {
    Index: '106',
    Default: 'Total Debit',
    Label: 'Débit total',
  },
  {
    Index: '107',
    Default: 'Net Amount',
    Label: 'Montant net',
  },
  {
    Index: '108',
    Default: 'Total Transactions',
    Label: 'Total des transactions',
  },
  {
    Index: '109',
    Default: 'Period',
    Label: 'Période',
  },
  {
    Index: '110',
    Default: 'Account Number',
    Label: 'Numéro de compte',
  },
  {
    Index: '111',
    Default: 'Account number',
    Label: 'Numéro de compte',
  },
  {
    Index: '112',
    Default: 'Currency',
    Label: 'Devise',
  },
  {
    Index: '113',
    Default: 'Balance',
    Label: 'Solde',
  },
  {
    Index: '114',
    Default: 'Available Balance',
    Label: 'Solde disponible',
  },
  {
    Index: '115',
    Default: 'Between own accounts',
    Label: 'Entre mes comptes',
  },
  {
    Index: '116',
    Default: 'To AGB',
    Label: 'Vers un compte AGB',
  },
  {
    Index: '117',
    Default: 'To Another Bank Account',
    Label: 'Vers une autre banque',
  },
  {
    Index: '118',
    Default: 'To Mobile Operator',
    Label: 'Vers un opérateur mobile',
  },
  {
    Index: '119',
    Default: 'Transfer to',
    Label: 'Transférer vers',
  },
  {
    Index: '120',
    Default: 'Transfer',
    Label: 'Transférer',
  },
  {
    Index: '121',
    Default: 'Operator',
    Label: 'Opérateur',
  },
  {
    Index: '122',
    Default: 'Withdraw using an agent',
    Label: "Retrait auprès d'un agent",
  },
  {
    Index: '123',
    Default: 'Cash Withdrawal',
    Label: "Retrait d'espèces",
  },
  {
    Index: '124',
    Default: 'Add Beneficiary',
    Label: 'Ajouter un bénéficiaire',
  },
  {
    Index: '125',
    Default: 'Edit Beneficiary',
    Label: 'Modifier le bénéficiaire',
  },
  {
    Index: '126',
    Default: 'Delete Beneficiary',
    Label: 'Supprimer le bénéficiaire',
  },
  {
    Index: '127',
    Default: 'Search beneficiaries',
    Label: 'Rechercher des bénéficiaires',
  },
  {
    Index: '128',
    Default: 'Beneficiary Name',
    Label: 'Nom du bénéficiaire',
  },
  {
    Index: '129',
    Default: 'Bank Name',
    Label: 'Nom de la banque',
  },
  {
    Index: '130',
    Default: 'Search',
    Label: 'Rechercher',
  },
  {
    Index: '131',
    Default: 'Filter',
    Label: 'Filtrer',
  },
  {
    Index: '132',
    Default: 'All',
    Label: 'Tous',
  },
  {
    Index: '133',
    Default: 'Completed',
    Label: 'Terminé',
  },
  {
    Index: '134',
    Default: 'Pending',
    Label: 'En attente',
  },
  {
    Index: '135',
    Default: 'Failed',
    Label: 'Échoué',
  },
  {
    Index: '136',
    Default: 'Debit',
    Label: 'Débit',
  },
  {
    Index: '137',
    Default: 'Credit',
    Label: 'Crédit',
  },
  {
    Index: '138',
    Default: 'Description',
    Label: 'Description',
  },
  {
    Index: '139',
    Default: 'Amount',
    Label: 'Montant',
  },
  {
    Index: '140',
    Default: 'Reference',
    Label: 'Référence',
  },
  {
    Index: '141',
    Default: 'Date',
    Label: 'Date',
  },
  {
    Index: '142',
    Default: 'Status',
    Label: 'Statut',
  },
  {
    Index: '143',
    Default: 'Actions',
    Label: 'Actions',
  },
  {
    Index: '144',
    Default: 'Download',
    Label: 'Télécharger',
  },
  {
    Index: '145',
    Default: 'Download PDF',
    Label: 'Télécharger en PDF',
  },
  {
    Index: '146',
    Default: 'Download Excel',
    Label: 'Télécharger en Excel',
  },
  {
    Index: '147',
    Default: 'Start Date',
    Label: 'Date de début',
  },
  {
    Index: '148',
    Default: 'End Date',
    Label: 'Date de fin',
  },
  {
    Index: '149',
    Default: 'Format',
    Label: 'Format',
  },
  {
    Index: '150',
    Default: 'Transaction ID',
    Label: 'ID de transaction',
  },
  {
    Index: '151',
    Default: 'of',
    Label: 'sur',
  },
  {
    Index: '152',
    Default: 'transactions',
    Label: 'Transactions',
  },
  {
    Index: '153',
    Default: 'Home',
    Label: 'Accueil',
  },
  {
    Index: '154',
    Default: 'Accounts',
    Label: 'Comptes',
  },
  {
    Index: '155',
    Default: 'Transactions',
    Label: 'Transactions',
  },
  {
    Index: '156',
    Default: 'Pay Bills',
    Label: 'Payer des factures',
  },
  {
    Index: '157',
    Default: 'Cards',
    Label: 'Cartes',
  },
  {
    Index: '158',
    Default: 'Beneficiaries',
    Label: 'Bénéficiaires',
  },
  {
    Index: '159',
    Default: 'Loans',
    Label: 'Prêts',
  },
  {
    Index: '160',
    Default: 'Organization',
    Label: 'Organisation',
  },
  {
    Index: '161',
    Default: 'Profile',
    Label: 'Profil',
  },
  {
    Index: '162',
    Default: 'Tellers',
    Label: 'Guichetiers',
  },
  {
    Index: '163',
    Default: 'Logout',
    Label: 'Déconnexion',
  },
  {
    Index: '164',
    Default: 'Settings',
    Label: 'Paramètres',
  },
  {
    Index: '165',
    Default: 'Verified',
    Label: 'Vérifié',
  },
  {
    Index: '166',
    Default: 'Unverified',
    Label: 'Non vérifié',
  },
  {
    Index: '167',
    Default: 'Rejected',
    Label: 'Rejeté',
  },
  {
    Index: '168',
    Default: 'Single',
    Label: 'Célibataire',
  },
  {
    Index: '169',
    Default: 'Married',
    Label: 'Marié(e)',
  },
  {
    Index: '170',
    Default: 'Divorced',
    Label: 'Divorcé(e)',
  },
  {
    Index: '171',
    Default: 'Widowed',
    Label: 'Veuf/Veuve',
  },
  {
    Index: '172',
    Default: 'Male',
    Label: 'Masculin',
  },
  {
    Index: '173',
    Default: 'Female',
    Label: 'Féminin',
  },
  {
    Index: '174',
    Default: 'Personal Information',
    Label: 'Renseignements personnels',
  },
  {
    Index: '175',
    Default: 'Personal information',
    Label: 'Renseignements personnels',
  },
  {
    Index: '176',
    Default: 'Security',
    Label: 'Sécurité',
  },
  {
    Index: '177',
    Default: 'Support',
    Label: 'Support',
  },
  {
    Index: '178',
    Default: 'Birth Information',
    Label: 'Informations de naissance',
  },
  {
    Index: '179',
    Default: 'Verification Status',
    Label: 'Statut de vérification',
  },
  {
    Index: '180',
    Default: 'Criminal Record',
    Label: 'Casier judiciaire',
  },
  {
    Index: '181',
    Default: 'Bank Record',
    Label: 'Dossier bancaire',
  },
  {
    Index: '182',
    Default: 'Status',
    Label: 'Statut',
  },
  {
    Index: '183',
    Default: 'Clean',
    Label: 'Conforme',
  },
  {
    Index: '184',
    Default: 'Has Record',
    Label: 'Antécédent',
  },
  {
    Index: '185',
    Default: 'Good Standing',
    Label: 'En règle',
  },
  {
    Index: '186',
    Default: 'Issues Found',
    Label: 'Irrégularité',
  },
  {
    Index: '187',
    Default: 'Active',
    Label: 'Actif',
  },
  {
    Index: '188',
    Default: 'Inactive',
    Label: 'Inactif',
  },
  {
    Index: '189',
    Default: 'Not provided',
    Label: 'Non renseigné',
  },
  {
    Index: '190',
    Default: 'Proof of Residence',
    Label: 'Justificatif de domicile',
  },
  {
    Index: '191',
    Default: 'Identification Information',
    Label: "Pièces d'identité",
  },
  {
    Index: '192',
    Default: 'Manage',
    Label: 'Gérer',
  },
  {
    Index: '193',
    Default: 'Provided',
    Label: 'Fourni',
  },
  {
    Index: '194',
    Default: 'Pending',
    Label: 'En attente',
  },
  {
    Index: '195',
    Default: 'Documents',
    Label: 'Documents & Justificatifs',
  },
  {
    Index: '196',
    Default: 'Your profile is verified and active',
    Label: 'Votre profil est vérifié et actif',
  },
  {
    Index: '197',
    Default:
      'All features and payment operations are fully accessible.',
    Label:
      'Toutes les fonctionnalités et opérations de paiement sont pleinement accessibles.',
  },
  {
    Index: '198',
    Default: "Let's set up your account",
    Label: 'Configurons votre compte',
  },
  {
    Index: '199',
    Default:
      'Please verify your identity documents to unlock all account features and higher transaction limits.',
    Label:
      'Veuillez vérifier vos pièces d’identité pour débloquer toutes les fonctionnalités et des plafonds de transaction plus élevés.',
  },
  {
    Index: '200',
    Default: 'Stay Logged In',
    Label: 'Rester connecté',
  },
  {
    Index: '201',
    Default: 'Session Timeout Warning',
    Label: "Avertissement d'expiration de session",
  },
  {
    Index: '202',
    Default:
      'You have been inactive for a while. Your session will time out in',
    Label: 'Vous êtes inactif depuis un moment. Votre session expirera dans :',
  },
  {
    Index: '203',
    Default: 'minutes',
    Label: 'minutes',
  },
  {
    Index: '204',
    Default: 'Session Locked',
    Label: 'Session verrouillée',
  },
  {
    Index: '205',
    Default:
      'Please enter your password to continue without losing your current progress.',
    Label:
      'Veuillez saisir votre mot de passe pour continuer sans perdre votre progression.',
  },
  {
    Index: '206',
    Default: 'Enter your password',
    Label: 'Saisissez votre mot de passe',
  },
  {
    Index: '207',
    Default: 'Unlock & Continue',
    Label: 'Déverrouiller et continuer',
  },
  {
    Index: '208',
    Default: 'Resume Session',
    Label: 'Reprendre la session',
  },
  {
    Index: '209',
    Default: 'Authenticating...',
    Label: 'Authentification en cours...',
  },
  {
    Index: '210',
    Default: 'Log in with another account',
    Label: 'Se connecter avec un autre compte',
  },
  {
    Index: '211',
    Default: 'Incorrect password. Please try again.',
    Label: 'Mot de passe incorrect. Veuillez réessayer.',
  },
  {
    Index: '212',
    Default: 'Session successfully restored!',
    Label: 'Session restaurée avec succès !',
  },
  {
    Index: '213',
    Default: 'Proof of address uploaded',
    Label: 'Justificatif de domicile envoyé',
  },
  {
    Index: '214',
    Default: 'Utility bill or tax certificate',
    Label: "Facture d'eau/électricité ou avis d'imposition",
  },
  {
    Index: '215',
    Default: 'National ID / Passport',
    Label: "Pièce d'identité / Passeport",
  },
  {
    Index: '216',
    Default: 'Passport',
    Label: 'Passeport',
  },
  {
    Index: '217',
    Default: 'ID Card',
    Label: "Carte d'identité",
  },
  {
    Index: '218',
    Default: 'Driving License',
    Label: 'Permis de conduire',
  },
  {
    Index: '219',
    Default: 'Residence Permit',
    Label: 'Titre de séjour',
  },
  {
    Index: '220',
    Default: 'Verify now',
    Label: 'Vérifier maintenant',
  },
  {
    Index: '221',
    Default: 'Customer ID',
    Label: 'Identifiant client',
  },
  {
    Index: '222',
    Default: 'Password',
    Label: 'Mot de passe',
  },
  {
    Index: '223',
    Default: 'Unlock Session',
    Label: 'Déverrouiller la session',
  },
  {
    Index: '224',
    Default: 'National ID',
    Label: "Carte nationale d'identité",
  },
  {
    Index: '225',
    Default: "Driver's License",
    Label: 'Permis de conduire',
  },
  {
    Index: '226',
    Default: 'Please enter your password',
    Label: 'Veuillez saisir votre mot de passe',
  },
  {
    Index: '227',
    Default: 'Security code (OTP)',
    Label: 'Code de sécurité (OTP)',
  },
  {
    Index: '228',
    Default: 'Please enter the OTP code sent to your phone or email',
    Label: 'Veuillez saisir le code OTP envoyé à votre téléphone ou email',
  },
  {
    Index: '229',
    Default: 'Verify & Unlock',
    Label: 'Vérifier et déverrouiller',
  },
  {
    Index: '230',
    Default: 'Resend code',
    Label: 'Renvoyer le code',
  },
  {
    Index: '231',
    Default: 'Back to password',
    Label: 'Retour au mot de passe',
  },
  {
    Index: '232',
    Default: 'OTP Code',
    Label: 'Code OTP',
  },
  {
    Index: '233',
    Default:
      'A security code (OTP) has been sent to your registered phone/email.',
    Label:
      'Un code de sécurité (OTP) a été envoyé à votre numéro/email enregistré.',
  },
  {
    Index: '234',
    Default: 'Please enter the OTP code',
    Label: 'Veuillez saisir le code OTP',
  },
  {
    Index: '235',
    Default: 'From your G-banking account to any destination you choose',
    Label: 'Depuis votre compte bancaire vers la destination de votre choix',
  },
  {
    Index: '236',
    Default: 'Shops & Supermarkets',
    Label: 'Commerces & Supermarchés',
  },
  {
    Index: '237',
    Default:
      'Easily access your saved contacts for payments and transfers',
    Label:
      'Accédez facilement à vos contacts enregistrés pour les paiements et les virements',
  },
  {
    Index: '238',
    Default: 'New Beneficiary',
    Label: 'Nouveau bénéficiaire',
  },
  {
    Index: '239',
    Default: 'Bills',
    Label: 'Factures',
  },
  {
    Index: '240',
    Default: 'Choose a biller for payments',
    Label: 'Choisissez un facturier pour les paiements',
  },
  {
    Index: '241',
    Default: 'Send money to an account',
    Label: "Envoyer de l'argent vers un compte",
  },
  {
    Index: '242',
    Default: 'Operators',
    Label: 'Opérateurs mobiles',
  },
  {
    Index: '243',
    Default: 'Send money to a mobile wallet',
    Label: "Envoyer de l'argent vers un portefeuille mobile",
  },
  {
    Index: '244',
    Default: 'Search beneficiary by name, account or phone...',
    Label: 'Rechercher par nom, compte ou téléphone...',
  },
  {
    Index: '245',
    Default: 'Search a bill category or provider...',
    Label: 'Rechercher un service, une facture...',
  },
  {
    Index: '246',
    Default: 'Total beneficiaries',
    Label: 'Total bénéficiaires',
  },
  {
    Index: '247',
    Default: 'Copy account number',
    Label: 'Copier le numéro de compte',
  },
  {
    Index: '248',
    Default: 'Account number copied!',
    Label: 'Numéro de compte copié !',
  },
  {
    Index: '249',
    Default: 'Copied!',
    Label: 'Copié !',
  },
  {
    Index: '250',
    Default: 'No beneficiaries found',
    Label: 'Aucun bénéficiaire enregistré',
  },
  {
    Index: '251',
    Default: 'No beneficiaries match your search',
    Label: 'Aucun bénéficiaire ne correspond à votre recherche',
  },
  {
    Index: '252',
    Default:
      'Add your first beneficiary to start making quick transfers and payments.',
    Label:
      'Enregistrez vos bénéficiaires pour effectuer des virements et paiements en un clic.',
  },
  {
    Index: '253',
    Default: 'Clear search',
    Label: 'Réinitialiser la recherche',
  },
  {
    Index: '254',
    Default: 'Mobile top-up and bundles',
    Label: 'Recharge mobile et forfaits',
  },
  {
    Index: '255',
    Default: 'Internet bundles & fiber',
    Label: 'Pass internet et fibre optique',
  },
  {
    Index: '256',
    Default: 'Prepaid meter recharge',
    Label: 'Recharge compteurs prépayés',
  },
  {
    Index: '257',
    Default: 'eSIM bundles & activation',
    Label: 'Forfaits et activations eSIM',
  },
  {
    Index: '258',
    Default: 'Water and electricity bills',
    Label: 'Factures eau et électricité',
  },
  {
    Index: '259',
    Default: 'In-store shopping and retail',
    Label: 'Achats et règlements en magasin',
  },
  {
    Index: '260',
    Default: 'Canal+, TV packages & channels',
    Label: 'Canal+, bouquets et chaînes TV',
  },
  {
    Index: '261',
    Default: 'Taxes, duties & public services',
    Label: 'Taxes, impôts et services publics',
  },
  {
    Index: '262',
    Default: 'Services available',
    Label: 'services disponibles',
  },
  {
    Index: '263',
    Default: 'Beneficiaries saved',
    Label: 'bénéficiaires enregistrés',
  },
  {
    Index: '264',
    Default: 'No bill categories were found',
    Label: 'Aucune catégorie de facture trouvée',
  },
  {
    Index: '265',
    Default: 'Bank Transfer',
    Label: 'Virement bancaire',
  },
  {
    Index: '266',
    Default: 'Mobile Wallet',
    Label: 'Portefeuille mobile',
  },
  {
    Index: '267',
    Default: 'Bill Payment',
    Label: 'Paiement de facture',
  },
  {
    Index: '268',
    Default: 'All services',
    Label: 'Tous les services',
  },
  {
    Index: '269',
    Default: 'success',
    Label: 'Succès',
  },
  {
    Index: '270',
    Default: 'Success',
    Label: 'Succès',
  },
  {
    Index: '271',
    Default: 'pending',
    Label: 'En attente',
  },
  {
    Index: '272',
    Default: 'Pending',
    Label: 'En attente',
  },
  {
    Index: '273',
    Default: 'failed',
    Label: 'Échoué',
  },
  {
    Index: '274',
    Default: 'Failed',
    Label: 'Échoué',
  },
  {
    Index: '275',
    Default: 'cancelled',
    Label: 'Annulé',
  },
  {
    Index: '276',
    Default: 'Cancelled',
    Label: 'Annulé',
  },
  {
    Index: '277',
    Default: 'All transactions',
    Label: 'Toutes les transactions',
  },
  {
    Index: '278',
    Default: 'Select columns to display',
    Label: 'Sélectionner les colonnes à afficher',
  },
  {
    Index: '279',
    Default:
      'Hide unwanted columns here (e.g., Details). Table updates instantly',
    Label:
      'Masquez les colonnes souhaitées. Le tableau se met à jour instantanément',
  },
  {
    Index: '280',
    Default: 'Export transactions to XLSX',
    Label: 'Exporter les transactions en XLSX',
  },
  {
    Index: '281',
    Default: 'Search transactions by description or ID...',
    Label: 'Rechercher par description ou identifiant...',
  },
  {
    Index: '282',
    Default: 'No external transactions found',
    Label: 'Aucune transaction trouvée',
  },
  {
    Index: '283',
    Default: 'Copy transaction ID',
    Label: "Copier l'ID de transaction",
  },
  {
    Index: '284',
    Default: 'Transaction ID copied!',
    Label: 'ID de transaction copié !',
  },
  {
    Index: '285',
    Default: 'Total transactions',
    Label: 'Total transactions',
  },
  {
    Index: '286',
    Default: 'Primary account',
    Label: 'Compte principal',
  },
  {
    Index: '287',
    Default: 'Export XLSX',
    Label: 'Exporter XLSX',
  },
  {
    Index: '288',
    Default: 'Details',
    Label: 'Détails',
  },
  {
    Index: '289',
    Default: 'Type',
    Label: 'Type',
  },
  {
    Index: '290',
    Default: 'Reload',
    Label: 'Actualiser',
  },
  {
    Index: '291',
    Default: 'Refresh',
    Label: 'Actualiser',
  },
  {
    Index: '292',
    Default: 'Columns',
    Label: 'Colonnes',
  },
  {
    Index: '293',
    Default: 'Previous Balance',
    Label: 'Solde précédent',
  },
  {
    Index: '294',
    Default: 'New Balance',
    Label: 'Nouveau solde',
  },
  {
    Index: '295',
    Default: 'Wallet Number',
    Label: 'Numéro de compte',
  },
  {
    Index: '296',
    Default: 'Target Account',
    Label: 'Compte destinataire',
  },
  {
    Index: '297',
    Default: 'Transaction Number',
    Label: 'Numéro de transaction',
  },
  {
    Index: '298',
    Default: 'INSIGHTS',
    Label: 'Statistiques',
  },
  {
    Index: '299',
    Default: 'Insights',
    Label: 'Statistiques',
  },
  {
    Index: '300',
    Default: 'insights',
    Label: 'Statistiques',
  },
  {
    Index: '301',
    Default: 'in',
    Label: 'Entrées',
  },
  {
    Index: '302',
    Default: 'IN',
    Label: 'Entrées',
  },
  {
    Index: '303',
    Default: 'out',
    Label: 'Sorties',
  },
  {
    Index: '304',
    Default: 'OUT',
    Label: 'Sorties',
  },
  {
    Index: '305',
    Default: 'Inflows',
    Label: 'Entrées',
  },
  {
    Index: '306',
    Default: 'Outflows',
    Label: 'Sorties',
  },
  {
    Index: '307',
    Default: 'Mini statement',
    Label: 'Relevé simplifié',
  },
  {
    Index: '308',
    Default: 'MINI STATEMENT',
    Label: 'RELEVÉ SIMPLIFIÉ',
  },
  {
    Index: '309',
    Default: 'Account Details',
    Label: 'Détails du compte',
  },
  {
    Index: '310',
    Default: 'Account details',
    Label: 'Détails du compte',
  },
  {
    Index: '311',
    Default: 'Account statement',
    Label: 'Relevé de compte',
  },
  {
    Index: '312',
    Default: 'See all',
    Label: 'Voir tout',
  },
  {
    Index: '313',
    Default: 'Transaction Report',
    Label: 'Rapport de transaction',
  },
  {
    Index: '314',
    Default: 'Account Name',
    Label: 'Libellé du compte',
  },
  {
    Index: '315',
    Default: 'Account Number',
    Label: 'Numéro de compte',
  },
  {
    Index: '316',
    Default: 'Account number',
    Label: 'Numéro de compte',
  },
  {
    Index: '317',
    Default: 'Available balance',
    Label: 'Solde disponible',
  },
  {
    Index: '318',
    Default: 'Monthly Overview',
    Label: 'Aperçu mensuel',
  },
  {
    Index: '319',
    Default: 'Monthly Insights',
    Label: 'Statistiques mensuelles',
  },
  {
    Index: '320',
    Default: 'Hide amounts',
    Label: 'Masquer les montants',
  },
  {
    Index: '321',
    Default: 'Show amounts',
    Label: 'Afficher les montants',
  },
  {
    Index: '322',
    Default: 'Account copied!',
    Label: 'Numéro de compte copié !',
  },
  {
    Index: '323',
    Default: 'Copy account number',
    Label: 'Copier le numéro de compte',
  },
  {
    Index: '324',
    Default: 'Recent transactions',
    Label: 'Transactions récentes',
  },
  {
    Index: '325',
    Default: 'Total credits',
    Label: 'Total des crédits',
  },
  {
    Index: '326',
    Default: 'Total debits',
    Label: 'Total des débits',
  },
  {
    Index: '327',
    Default: 'See all history',
    Label: "Voir tout l'historique",
  },
  {
    Index: '328',
    Default: 'Account overview',
    Label: 'Aperçu du compte',
  },
  {
    Index: '329',
    Default: 'Welcome to the future of G-banking and seamless money transfer',
    Label: 'Bienvenue sur votre espace bancaire fluide et sécurisé',
  },
  {
    Index: '330',
    Default: 'AGB to AGB',
    Label: 'Virement AGB',
  },
  {
    Index: '331',
    Default: 'AGB to Banks',
    Label: 'Autre banque',
  },
  {
    Index: '332',
    Default: 'To Another Bank Account',
    Label: 'Autre banque',
  },
  {
    Index: '333',
    Default: 'Open savings',
    Label: 'Compte épargne',
  },
  {
    Index: '334',
    Default: 'Between own accounts',
    Label: 'Mes comptes',
  },
  {
    Index: '335',
    Default: 'Top up',
    Label: 'Recharger compte',
  },
  {
    Index: '336',
    Default: 'Prepaid card',
    Label: 'Carte prépayée',
  },
  {
    Index: '337',
    Default: 'Electricity & water',
    Label: 'Électricité & eau',
  },
  {
    Index: '338',
    Default: 'Taxes and Collections',
    Label: 'Impôts & taxes',
  },
  {
    Index: '339',
    Default: 'Airtime',
    Label: 'Recharge mobile',
  },
  {
    Index: '340',
    Default: 'New Operation',
    Label: 'Nouvelle opération',
  },
  {
    Index: '341',
    Default: 'All',
    Label: 'Tous les services',
  },
  {
    Index: '342',
    Default: 'Secondary account',
    Label: 'Compte secondaire',
  },
  {
    Index: '343',
    Default: 'Active account',
    Label: 'Compte actif',
  },
  {
    Index: '344',
    Default: 'Select this account',
    Label: 'Sélectionner ce compte',
  },
  {
    Index: '345',
    Default: 'Manage your accounts, check balances and track live cashflow.',
    Label: 'Gérez vos comptes, consultez vos soldes et suivez vos flux financiers en temps réel.',
  },
  {
    Index: '346',
    Default: 'Inflow',
    Label: 'Entrées',
  },
  {
    Index: '347',
    Default: 'Outflow',
    Label: 'Sorties',
  },
  {
    Index: '348',
    Default: 'Account label',
    Label: 'Titulaire du compte',
  },
  {
    Index: '349',
    Default: 'Transfer Information',
    Label: 'Informations sur le transfert',
  },
  {
    Index: '350',
    Default: 'Technical details',
    Label: 'Détails techniques & Traçabilité',
  },
  {
    Index: '351',
    Default: 'Partner Reference',
    Label: 'Référence partenaire',
  },
  {
    Index: '352',
    Default: 'Operational payment receipt',
    Label: 'Reçu de paiement opérationnel',
  },
  {
    Index: '353',
    Default: 'Organization Info',
    Label: "Informations sur l'organisation",
  },
  {
    Index: '354',
    Default: 'Organisation Info',
    Label: "Informations sur l'organisation",
  },
  {
    Index: '355',
    Default: 'Operations',
    Label: 'Opérations',
  },
  {
    Index: '356',
    Default: 'Export Operations',
    Label: 'Exporter XLSX',
  },
  {
    Index: '357',
    Default: 'Export XLSX',
    Label: 'Exporter XLSX',
  },
  {
    Index: '358',
    Default: 'Sub organizations',
    Label: 'Sous-organisations',
  },
  {
    Index: '359',
    Default: 'Helps',
    Label: 'Assistants',
  },
  {
    Index: '360',
    Default: 'Flat fee per transaction',
    Label: 'Frais forfaitaires / transaction',
  },
  {
    Index: '361',
    Default: 'Using a flat amount per transaction',
    Label: 'Frais forfaitaires par transaction',
  },
  {
    Index: '362',
    Default: 'No Operation yet',
    Label: 'Aucune opération enregistrée',
  },
  {
    Index: '363',
    Default: 'Executed on',
    Label: 'Exécuté le',
  },
  {
    Index: '364',
    Default: 'Executed',
    Label: 'Exécuté',
  },
  {
    Index: '365',
    Default: 'Not executed',
    Label: 'Non exécuté',
  },
  {
    Index: '366',
    Default: 'Manage and monitor all your batch bulk payments',
    Label: 'Gérez et suivez tous vos paiements de masse',
  },
  {
    Index: '367',
    Default: 'TIN',
    Label: 'NIF',
  },
  {
    Index: '368',
    Default: 'Select operator',
    Label: "Sélectionner l'opérateur",
  },
  {
    Index: '369',
    Default: 'Enter reason here',
    Label: 'Motif (optionnel)',
  },
  {
    Index: '370',
    Default: 'Save the Beneficiary',
    Label: 'Enregistrer le bénéficiaire',
  },
  {
    Index: '371',
    Default: 'Save the beneficiary',
    Label: 'Enregistrer le bénéficiaire',
  },
  {
    Index: '372',
    Default: 'Select a beneficiary',
    Label: 'Sélectionner un bénéficiaire',
  },
  {
    Index: '373',
    Default: 'Choose from your saved contacts',
    Label: 'Choisir parmi vos contacts enregistrés',
  },
  {
    Index: '374',
    Default: 'Quick amounts',
    Label: 'Montants suggérés',
  },
  {
    Index: '375',
    Default: 'Bill number',
    Label: 'Numéro de facture / compte',
  },
  {
    Index: '376',
    Default: 'Enter the amount here',
    Label: 'Entrez le montant ici',
  },
  {
    Index: '377',
    Default: 'Mobile Top-up',
    Label: 'Recharge mobile',
  },
  {
    Index: '378',
    Default: 'TV Operator / Distributor',
    Label: 'Télédistributeur / Opérateur',
  },
  {
    Index: '379',
    Default: 'Service Provider',
    Label: 'Fournisseur de service',
  },
  {
    Index: '380',
    Default: 'Internet Service Provider',
    Label: 'Fournisseur d’accès Internet',
  },
  {
    Index: '381',
    Default: 'Mobile Operator',
    Label: 'Opérateur mobile',
  },
  {
    Index: '382',
    Default: 'Payment reason (optional)',
    Label: 'Motif du paiement (optionnel)',
  },
  {
    Index: '383',
    Default: 'Recharge reason (optional)',
    Label: 'Motif de la recharge (optionnel)',
  },
  {
    Index: '384',
    Default: 'Operator',
    Label: 'Opérateur',
  },
  {
    Index: '385',
    Default: 'To view your account balance, please enter your 6-digit PIN',
    Label: 'Pour afficher le solde de votre compte, veuillez entrer votre code PIN à 6 chiffres',
  },
  {
    Index: '386',
    Default: 'Enter PIN to confirm',
    Label: 'Entrez le code PIN pour confirmer',
  },
  {
    Index: '387',
    Default: 'Please enter your 6-digit PIN',
    Label: 'Veuillez entrer votre code PIN à 6 chiffres',
  },
  {
    Index: '388',
    Default: 'Change PIN',
    Label: 'Modifier le code PIN',
  },
  {
    Index: "389",
    Default: " & I",
    Label: " & Moi",
  },
  {
    Index: "390",
    Default: "8 characters long",
    Label: "8 caractères de long",
  },
  {
    Index: "391",
    Default: "A bank agent is reviewing your application",
    Label: "Un agent de la banque examine votre demande",
  },
  {
    Index: "392",
    Default: "Accept",
    Label: "Accepter",
  },
  {
    Index: "393",
    Default: "Access",
    Label: "Accès",
  },
  {
    Index: "394",
    Default: "Account",
    Label: "Compte",
  },
  {
    Index: "395",
    Default: "Account Information",
    Label: "Informations sur le compte",
  },
  {
    Index: "396",
    Default: "Account limits",
    Label: "Plafonds du compte",
  },
  {
    Index: "397",
    Default: "Account opened",
    Label: "Compte ouvert",
  },
  {
    Index: "398",
    Default: "Account type",
    Label: "Type de compte",
  },
  {
    Index: "399",
    Default: "Account/Bill Number",
    Label: "Numéro de compte / facture",
  },
  {
    Index: "400",
    Default: "Action",
    Label: "Action",
  },
  {
    Index: "401",
    Default: "Active loan",
    Label: "Prêt actif",
  },
  {
    Index: "402",
    Default: "Add Another Recipient",
    Label: "Ajouter un autre bénéficiaire",
  },
  {
    Index: "403",
    Default: "Add Helper",
    Label: "Ajouter un assistant",
  },
  {
    Index: "404",
    Default: "Add Helpers",
    Label: "Ajouter des assistants",
  },
  {
    Index: "405",
    Default: "Add Manually",
    Label: "Ajouter manuellement",
  },
  {
    Index: "406",
    Default: "Add New Recipient",
    Label: "Ajouter un nouveau bénéficiaire",
  },
  {
    Index: "407",
    Default: "Add a helper",
    Label: "Ajouter un assistant",
  },
  {
    Index: "408",
    Default: "Address",
    Label: "Adresse",
  },
  {
    Index: "409",
    Default: "Address / Quarter",
    Label: "Adresse / Quartier",
  },
  {
    Index: "410",
    Default: "Agent Cash Withdrawal",
    Label: "Retrait d'espèces par agent",
  },
  {
    Index: "411",
    Default: "Agree and Continue",
    Label: "Accepter et continuer",
  },
  {
    Index: "412",
    Default: "All edits applied",
    Label: "Toutes les modifications ont été appliquées",
  },
  {
    Index: "413",
    Default: "All set!",
    Label: "Tout est prêt !",
  },
  {
    Index: "414",
    Default: "Allow user to create new operations",
    Label: "Autoriser l'utilisateur à créer de nouvelles opérations",
  },
  {
    Index: "415",
    Default: "Allow user to link bank accounts",
    Label: "Autoriser l'utilisateur à lier des comptes bancaires",
  },
  {
    Index: "416",
    Default: "Allow user to print transaction reports",
    Label: "Autoriser l'utilisateur à imprimer les rapports de transaction",
  },
  {
    Index: "417",
    Default: "Almost done",
    Label: "Presque terminé",
  },
  {
    Index: "418",
    Default: "Already registered?",
    Label: "Déjà inscrit ?",
  },
  {
    Index: "419",
    Default: "Amount Paid",
    Label: "Montant payé",
  },
  {
    Index: "420",
    Default: "Amount is required",
    Label: "Le montant est obligatoire",
  },
  {
    Index: "421",
    Default: "Amount must be a number",
    Label: "Le montant doit être un nombre",
  },
  {
    Index: "422",
    Default: "Amount to be sent",
    Label: "Montant à envoyer",
  },
  {
    Index: "423",
    Default: "Application",
    Label: "Demande",
  },
  {
    Index: "424",
    Default: "Application not found",
    Label: "Demande non trouvée",
  },
  {
    Index: "425",
    Default: "Application reference",
    Label: "Référence de la demande",
  },
  {
    Index: "426",
    Default: "Application submitted",
    Label: "Demande soumise",
  },
  {
    Index: "427",
    Default: "Application under review",
    Label: "Demande en cours d'examen",
  },
  {
    Index: "428",
    Default: "Apply for an instant loan",
    Label: "Demander un prêt instantané",
  },
  {
    Index: "429",
    Default: "Approved",
    Label: "Approuvé",
  },
  {
    Index: "430",
    Default: "Back to",
    Label: "Retour à",
  },
  {
    Index: "431",
    Default: "Back to login",
    Label: "Retour à la connexion",
  },
  {
    Index: "432",
    Default: "Back to previous step",
    Label: "Retour à l'étape précédente",
  },
  {
    Index: "433",
    Default: "Bank-grade encryption",
    Label: "Chiffrement de niveau bancaire",
  },
  {
    Index: "434",
    Default: "Batch Processing in Progress",
    Label: "Traitement par lot en cours",
  },
  {
    Index: "435",
    Default: "Batch processing paused. You can resume or cancel.",
    Label: "Traitement par lot suspendu. Vous pouvez reprendre ou annuler.",
  },
  {
    Index: "436",
    Default: "Batch processing resumed.",
    Label: "Traitement par lot repris.",
  },
  {
    Index: "437",
    Default: "Batch size set to",
    Label: "Taille de lot définie à",
  },
  {
    Index: "438",
    Default: "Beneficiary",
    Label: "Bénéficiaire",
  },
  {
    Index: "439",
    Default: "Beneficiary Details",
    Label: "Détails du bénéficiaire",
  },
  {
    Index: "440",
    Default: "Birth Date",
    Label: "Date de naissance",
  },
  {
    Index: "441",
    Default: "Brand Name",
    Label: "Nom de marque",
  },
  {
    Index: "442",
    Default: "CVV",
    Label: "CVV",
  },
  {
    Index: "443",
    Default: "Calculate",
    Label: "Calculer",
  },
  {
    Index: "444",
    Default: "Can add helpers",
    Label: "Peut ajouter des assistants",
  },
  {
    Index: "445",
    Default: "Can create operations",
    Label: "Peut créer des opérations",
  },
  {
    Index: "446",
    Default: "Can execute cash pooling",
    Label: "Peut exécuter le cash pooling",
  },
  {
    Index: "447",
    Default: "Can execute operations",
    Label: "Peut exécuter des opérations",
  },
  {
    Index: "448",
    Default: "Can link bank account",
    Label: "Peut lier un compte bancaire",
  },
  {
    Index: "449",
    Default: "Can print transaction",
    Label: "Peut imprimer les transactions",
  },
  {
    Index: "450",
    Default: "Cancel All",
    Label: "Tout annuler",
  },
  {
    Index: "451",
    Default: "Canceled Count",
    Label: "Nombre d'annulations",
  },
  {
    Index: "452",
    Default: "CANCELED",
    Label: "Annulé",
  },
  {
    Index: "453",
    Default: "Capture",
    Label: "Capturer",
  },
  {
    Index: "454",
    Default: "Card Details",
    Label: "Détails de la carte",
  },
  {
    Index: "455",
    Default: "Card is disabled",
    Label: "La carte est désactivée",
  },
  {
    Index: "456",
    Default: "Card is enabled",
    Label: "La carte est activée",
  },
  {
    Index: "457",
    Default: "Card type",
    Label: "Type de carte",
  },
  {
    Index: "458",
    Default: "Cash Pooling",
    Label: "Gestion de trésorerie (Cash Pooling)",
  },
  {
    Index: "459",
    Default: "Check status",
    Label: "Vérifier le statut",
  },
  {
    Index: "460",
    Default: "Choose File Format",
    Label: "Choisir le format de fichier",
  },
  {
    Index: "461",
    Default: "Choose a 6-digit PIN",
    Label: "Choisissez un code PIN à 6 chiffres",
  },
  {
    Index: "462",
    Default: "Choose a username",
    Label: "Choisissez un nom d'utilisateur",
  },
  {
    Index: "463",
    Default: "Clear All",
    Label: "Tout effacer",
  },
  {
    Index: "464",
    Default: "Click here",
    Label: "Cliquez ici",
  },
  {
    Index: "465",
    Default: "Closed on",
    Label: "Fermé le",
  },
  {
    Index: "466",
    Default: "Configure Batch Processing",
    Label: "Configurer le traitement par lot",
  },
  {
    Index: "467",
    Default: "Confirm PIN",
    Label: "Confirmer le code PIN",
  },
  {
    Index: "468",
    Default: "Confirm Password",
    Label: "Confirmer le mot de passe",
  },
  {
    Index: "469",
    Default: "Confirm your PIN number",
    Label: "Confirmez votre code PIN",
  },
  {
    Index: "470",
    Default: "Confirm your password",
    Label: "Confirmez votre mot de passe",
  },
  {
    Index: "471",
    Default: "Connect",
    Label: "Se connecter",
  },
  {
    Index: "472",
    Default: "Contact",
    Label: "Contact",
  },
  {
    Index: "473",
    Default: "Contact PID",
    Label: "PID du contact",
  },
  {
    Index: "474",
    Default: "Contact phone",
    Label: "Téléphone du contact",
  },
  {
    Index: "475",
    Default: "Copy card CVV",
    Label: "Copier le CVV",
  },
  {
    Index: "476",
    Default: "Copy card number",
    Label: "Copier le numéro de carte",
  },
  {
    Index: "477",
    Default: "Could not create your online access",
    Label: "Impossible de créer votre accès en ligne",
  },
  {
    Index: "478",
    Default: "Could not send the verification code",
    Label: "Impossible d'envoyer le code de vérification",
  },
  {
    Index: "479",
    Default: "Could not submit your application",
    Label: "Impossible de soumettre votre demande",
  },
  {
    Index: "480",
    Default: "Create Operation",
    Label: "Créer une opération",
  },
  {
    Index: "481",
    Default: "Create a new operation",
    Label: "Créer une nouvelle opération",
  },
  {
    Index: "482",
    Default: "Create my access",
    Label: "Créer mon accès",
  },
  {
    Index: "483",
    Default: "Create new password",
    Label: "Créer un nouveau mot de passe",
  },
  {
    Index: "484",
    Default: "Create new sub organization",
    Label: "Créer une nouvelle sous-organisation",
  },
  {
    Index: "485",
    Default: "Create your online access",
    Label: "Créez votre accès en ligne",
  },
  {
    Index: "486",
    Default: "Creation Date",
    Label: "Date de création",
  },
  {
    Index: "487",
    Default: "Current Balance",
    Label: "Solde actuel",
  },
  {
    Index: "488",
    Default: "Current PIN",
    Label: "Code PIN actuel",
  },
  {
    Index: "489",
    Default: "Current Password",
    Label: "Mot de passe actuel",
  },
  {
    Index: "490",
    Default: "Day of payment",
    Label: "Jour de paiement",
  },
  {
    Index: "491",
    Default: "Decision",
    Label: "Décision",
  },
  {
    Index: "492",
    Default: "Default limit",
    Label: "Plafond par défaut",
  },
  {
    Index: "493",
    Default: "Delete",
    Label: "Supprimer",
  },
  {
    Index: "494",
    Default: "Delete Confirmation",
    Label: "Confirmation de suppression",
  },
  {
    Index: "495",
    Default: "Delete Selected",
    Label: "Supprimer les éléments sélectionnés",
  },
  {
    Index: "496",
    Default: "Disabled",
    Label: "Désactivé",
  },
  {
    Index: "497",
    Default: "Disclaimer",
    Label: "Avertissement",
  },
  {
    Index: "498",
    Default: "Download Template",
    Label: "Télécharger le modèle",
  },
  {
    Index: "499",
    Default: "Download the QR Code",
    Label: "Télécharger le code QR",
  },
  {
    Index: "500",
    Default: "Duplicate",
    Label: "Dupliquer",
  },
  {
    Index: "501",
    Default: "Duration",
    Label: "Durée",
  },
  {
    Index: "502",
    Default: "Edit",
    Label: "Modifier",
  },
  {
    Index: "503",
    Default: "Edit Recipient",
    Label: "Modifier le bénéficiaire",
  },
  {
    Index: "504",
    Default: "Edit Selected",
    Label: "Modifier les éléments sélectionnés",
  },
  {
    Index: "505",
    Default: "Editing in progress",
    Label: "Modification en cours",
  },
  {
    Index: "506",
    Default: "Email",
    Label: "E-mail",
  },
  {
    Index: "507",
    Default: "Email notification",
    Label: "Notification par e-mail",
  },
  {
    Index: "508",
    Default: "Enabled",
    Label: "Activé",
  },
  {
    Index: "509",
    Default: "Enter a valid email",
    Label: "Entrez un e-mail valide",
  },
  {
    Index: "510",
    Default: "Enter address",
    Label: "Entrez l'adresse",
  },
  {
    Index: "511",
    Default: "Enter city",
    Label: "Entrez la ville",
  },
  {
    Index: "512",
    Default: "Enter document number",
    Label: "Entrez le numéro du document",
  },
  {
    Index: "513",
    Default: "Enter first name",
    Label: "Entrez le prénom",
  },
  {
    Index: "514",
    Default: "Enter last name",
    Label: "Entrez le nom",
  },
  {
    Index: "515",
    Default: "Enter reference",
    Label: "Entrez la référence",
  },
  {
    Index: "516",
    Default: "Enter the verification code",
    Label: "Entrez le code de vérification",
  },
  {
    Index: "517",
    Default: "Enter verification code",
    Label: "Entrez le code de vérification",
  },
  {
    Index: "518",
    Default: "Enter your current PIN!",
    Label: "Entrez votre code PIN actuel !",
  },
  {
    Index: "519",
    Default: "Enter your current password!",
    Label: "Entrez votre mot de passe actuel !",
  },
  {
    Index: "520",
    Default: "Enter your phone number",
    Label: "Entrez votre numéro de téléphone",
  },
  {
    Index: "521",
    Default: "Error saving batch",
    Label: "Erreur lors de l'enregistrement du lot",
  },
  {
    Index: "522",
    Default: "Error saving recipients",
    Label: "Erreur lors de l'enregistrement des bénéficiaires",
  },
  {
    Index: "523",
    Default: "Exchange Fees",
    Label: "Frais de change",
  },
  {
    Index: "524",
    Default: "Exchange rate",
    Label: "Taux de change",
  },
  {
    Index: "525",
    Default: "Execute",
    Label: "Exécuter",
  },
  {
    Index: "526",
    Default: "Execution Date",
    Label: "Date d'exécution",
  },
  {
    Index: "527",
    Default: "Expiration date",
    Label: "Date d'expiration",
  },
  {
    Index: "528",
    Default: "Export failed. Please try again.",
    Label: "Échec de l'exportation. Veuillez réessayer.",
  },
  {
    Index: "529",
    Default: "Export successful!",
    Label: "Exportation réussie !",
  },
  {
    Index: "530",
    Default: "External Fees",
    Label: "Frais externes",
  },
  {
    Index: "531",
    Default: "Failed to access camera",
    Label: "Impossible d'accéder à la caméra",
  },
  {
    Index: "532",
    Default: "Failed to save batch",
    Label: "Échec de l'enregistrement du lot",
  },
  {
    Index: "533",
    Default: "Failed to update some records",
    Label: "Échec de la mise à jour de certains enregistrements",
  },
  {
    Index: "534",
    Default: "Failed to upload file",
    Label: "Échec du téléchargement du fichier",
  },
  {
    Index: "535",
    Default: "Failure Count",
    Label: "Nombre d'échecs",
  },
  {
    Index: "536",
    Default: "Fees",
    Label: "Frais",
  },
  {
    Index: "537",
    Default: "File must contain columns",
    Label: "Le fichier doit contenir les colonnes",
  },
  {
    Index: "538",
    Default: "Fill in account details",
    Label: "Renseignez les détails du compte",
  },
  {
    Index: "539",
    Default: "Financial Information",
    Label: "Informations financières",
  },
  {
    Index: "540",
    Default: "First Name",
    Label: "Prénom",
  },
  {
    Index: "541",
    Default: "First name is required",
    Label: "Le prénom est obligatoire",
  },
  {
    Index: "542",
    Default: "Firt Name",
    Label: "Prénom",
  },
  {
    Index: "543",
    Default: "Fixed savings account",
    Label: "Compte d'épargne à terme",
  },
  {
    Index: "544",
    Default: "Forgot your PIN?",
    Label: "Code PIN oublié ?",
  },
  {
    Index: "545",
    Default: "Forgot your password?",
    Label: "Mot de passe oublié ?",
  },
  {
    Index: "546",
    Default: "Forgot your username or username?",
    Label: "Nom d'utilisateur oublié ?",
  },
  {
    Index: "547",
    Default: "Forgot your username?",
    Label: "Nom d'utilisateur oublié ?",
  },
  {
    Index: "548",
    Default: "From",
    Label: "De",
  },
  {
    Index: "549",
    Default: "Hello",
    Label: "Bonjour",
  },
  {
    Index: "550",
    Default: "Helper Permissions",
    Label: "Permissions de l'assistant",
  },
  {
    Index: "551",
    Default: "Helpers",
    Label: "Assistants",
  },
  {
    Index: "552",
    Default: "How can we reach you?",
    Label: "Comment pouvons-nous vous joindre ?",
  },
  {
    Index: "553",
    Default: "I gree",
    Label: "J'accepte",
  },
  {
    Index: "554",
    Default: "IBAN",
    Label: "IBAN",
  },
  {
    Index: "555",
    Default: "ID document",
    Label: "Pièce d'identité",
  },
  {
    Index: "556",
    Default: "ID document number",
    Label: "Numéro de pièce d'identité",
  },
  {
    Index: "557",
    Default: "ID document type",
    Label: "Type de pièce d'identité",
  },
  {
    Index: "558",
    Default: "Identity",
    Label: "Identité",
  },
  {
    Index: "559",
    Default: "Image must be smaller than 2MB!",
    Label: "L'image doit être inférieure à 2 Mo !",
  },
  {
    Index: "560",
    Default: "Image must be smaller than 5MB!",
    Label: "L'image doit être inférieure à 5 Mo !",
  },
  {
    Index: "561",
    Default: "Import from Excel",
    Label: "Importer depuis Excel",
  },
  {
    Index: "562",
    Default: "Instant Loans",
    Label: "Prêts instantanés",
  },
  {
    Index: "563",
    Default: "Interest ",
    Label: "Intérêt ",
  },
  {
    Index: "564",
    Default: "International transfer",
    Label: "Virement international",
  },
  {
    Index: "565",
    Default: "Invalid verification code",
    Label: "Code de vérification invalide",
  },
  {
    Index: "566",
    Default: "KYC compliant",
    Label: "Conforme KYC",
  },
  {
    Index: "567",
    Default: "La finance à votre porte",
    Label: "La finance à votre porte",
  },
  {
    Index: "568",
    Default: "Last Name",
    Label: "Nom de famille",
  },
  {
    Index: "569",
    Default: "Last name is required",
    Label: "Le nom de famille est obligatoire",
  },
  {
    Index: "570",
    Default: "Link Bank Account",
    Label: "Lier un compte bancaire",
  },
  {
    Index: "571",
    Default: "Loading data...",
    Label: "Chargement des données...",
  },
  {
    Index: "572",
    Default: "Loading terms...",
    Label: "Chargement des conditions...",
  },
  {
    Index: "573",
    Default: "Loan Details",
    Label: "Détails du prêt",
  },
  {
    Index: "574",
    Default: "Loan calculator",
    Label: "Simulateur de prêt",
  },
  {
    Index: "575",
    Default: "Loan term",
    Label: "Durée du prêt",
  },
  {
    Index: "576",
    Default: "Log Out",
    Label: "Se déconnecter",
  },
  {
    Index: "577",
    Default: "Login",
    Label: "Connexion",
  },
  {
    Index: "578",
    Default: "Marketplace",
    Label: "Marché",
  },
  {
    Index: "579",
    Default: "Max daily limit",
    Label: "Plafond journalier maximal",
  },
  {
    Index: "580",
    Default: "Max limit per transaction",
    Label: "Plafond maximal par transaction",
  },
  {
    Index: "581",
    Default: "Maximum limit",
    Label: "Plafond maximal",
  },
  {
    Index: "582",
    Default: "Missing account number",
    Label: "Numéro de compte manquant",
  },
  {
    Index: "583",
    Default: "Missing amount",
    Label: "Montant manquant",
  },
  {
    Index: "584",
    Default: "Missing currency",
    Label: "Devise manquante",
  },
  {
    Index: "585",
    Default: "Missing first name",
    Label: "Prénom manquant",
  },
  {
    Index: "586",
    Default: "Missing last name",
    Label: "Nom manquant",
  },
  {
    Index: "587",
    Default: "Missing operator",
    Label: "Opérateur manquant",
  },
  {
    Index: "588",
    Default: "Missing phone number",
    Label: "Numéro de téléphone manquant",
  },
  {
    Index: "589",
    Default: "Mobile Account",
    Label: "Compte mobile",
  },
  {
    Index: "590",
    Default: "Monthly fees",
    Label: "Frais mensuels",
  },
  {
    Index: "591",
    Default: "Monthly limit",
    Label: "Plafond mensuel",
  },
  {
    Index: "592",
    Default: "Monthly payment",
    Label: "Paiement mensuel",
  },
  {
    Index: "593",
    Default: "More",
    Label: "Plus",
  },
  {
    Index: "594",
    Default: "My Cards",
    Label: "Mes cartes",
  },
  {
    Index: "595",
    Default: "My wallets",
    Label: "Mes portefeuilles",
  },
  {
    Index: "596",
    Default: "Name",
    Label: "Nom",
  },
  {
    Index: "597",
    Default: "Names",
    Label: "Noms",
  },
  {
    Index: "598",
    Default: "Need Review",
    Label: "À examiner",
  },
  {
    Index: "599",
    Default: "Need help?",
    Label: "Besoin d'aide ?",
  },
  {
    Index: "600",
    Default: "New PIN",
    Label: "Nouveau code PIN",
  },
  {
    Index: "601",
    Default: "New Password",
    Label: "Nouveau mot de passe",
  },
  {
    Index: "602",
    Default: "New Recipients",
    Label: "Nouveaux bénéficiaires",
  },
  {
    Index: "603",
    Default: "New Sub Organization",
    Label: "Nouvelle sous-organisation",
  },
  {
    Index: "604",
    Default: "New application",
    Label: "Nouvelle demande",
  },
  {
    Index: "605",
    Default: "Nex payment due date",
    Label: "Date d'échéance du prochain paiement",
  },
  {
    Index: "606",
    Default: "Next payment due date",
    Label: "Date d'échéance du prochain paiement",
  },
  {
    Index: "607",
    Default: "No",
    Label: "Non",
  },
  {
    Index: "608",
    Default: "No Organization yet",
    Label: "Aucune organisation pour le moment",
  },
  {
    Index: "609",
    Default: "No Recipient yet",
    Label: "Aucun bénéficiaire pour le moment",
  },
  {
    Index: "610",
    Default: "No information to display",
    Label: "Aucune information à afficher",
  },
  {
    Index: "611",
    Default: "No users found",
    Label: "Aucun utilisateur trouvé",
  },
  {
    Index: "612",
    Default: "No valid recipients to save",
    Label: "Aucun bénéficiaire valide à enregistrer",
  },
  {
    Index: "613",
    Default: "Not paid",
    Label: "Non payé",
  },
  {
    Index: "614",
    Default: "Not validated",
    Label: "Non validé",
  },
  {
    Index: "615",
    Default: "Not yet an AGB customer? ",
    Label: "Pas encore client AGB ? ",
  },
  {
    Index: "616",
    Default: "Not yet registered? ",
    Label: "Pas encore inscrit ? ",
  },
  {
    Index: "617",
    Default: "Notice",
    Label: "Remarque",
  },
  {
    Index: "618",
    Default: "OTP",
    Label: "OTP",
  },
  {
    Index: "619",
    Default: "Okay",
    Label: "D'accord",
  },
  {
    Index: "620",
    Default: "Old Password",
    Label: "Ancien mot de passe",
  },
  {
    Index: "621",
    Default: "Online account opening",
    Label: "Ouverture de compte en ligne",
  },
  {
    Index: "622",
    Default: "Open an account",
    Label: "Ouvrir un compte",
  },
  {
    Index: "623",
    Default: "Operation Complete",
    Label: "Opération terminée",
  },
  {
    Index: "624",
    Default: "Operation Details",
    Label: "Détails de l'opération",
  },
  {
    Index: "625",
    Default: "Operation Name",
    Label: "Nom de l'opération",
  },
  {
    Index: "626",
    Default: "Operation Statistics",
    Label: "Statistiques de l'opération",
  },
  {
    Index: "627",
    Default: "Option List",
    Label: "Liste d'options",
  },
  {
    Index: "628",
    Default: "Organisation Name",
    Label: "Nom de l'organisation",
  },
  {
    Index: "629",
    Default: "Organization Details",
    Label: "Détails de l'organisation",
  },
  {
    Index: "630",
    Default: "Organization ID",
    Label: "ID de l'organisation",
  },
  {
    Index: "631",
    Default: "Organization Name",
    Label: "Nom de l'organisation",
  },
  {
    Index: "632",
    Default: "Original Amount",
    Label: "Montant initial",
  },
  {
    Index: "633",
    Default: "PIN must be 4-6 digits",
    Label: "Le code PIN doit comporter entre 4 et 6 chiffres",
  },
  {
    Index: "634",
    Default: "Paid",
    Label: "Payé",
  },
  {
    Index: "635",
    Default: "Partner Response",
    Label: "Réponse du partenaire",
  },
  {
    Index: "636",
    Default: "Password did not match",
    Label: "Le mot de passe ne correspond pas",
  },
  {
    Index: "637",
    Default: "Passwords do not match!",
    Label: "Les mots de passe ne correspondent pas !",
  },
  {
    Index: "638",
    Default: "Passwords match",
    Label: "Les mots de passe correspondent",
  },
  {
    Index: "639",
    Default: "Pay",
    Label: "Payer",
  },
  {
    Index: "640",
    Default: "Pay from wallet",
    Label: "Payer depuis le portefeuille",
  },
  {
    Index: "641",
    Default: "Pay off options",
    Label: "Options de remboursement",
  },
  {
    Index: "642",
    Default: "Pay this loan",
    Label: "Rembourser ce prêt",
  },
  {
    Index: "643",
    Default: "Payment Count",
    Label: "Nombre de paiements",
  },
  {
    Index: "644",
    Default: "Payment References",
    Label: "Références de paiement",
  },
  {
    Index: "645",
    Default: "Payment Status",
    Label: "Statut du paiement",
  },
  {
    Index: "646",
    Default: "Pending Count",
    Label: "Nombre en attente",
  },
  {
    Index: "647",
    Default: "Phone Number",
    Label: "Numéro de téléphone",
  },
  {
    Index: "648",
    Default: "Phone number (Optional)",
    Label: "Numéro de téléphone (optionnel)",
  },
  {
    Index: "649",
    Default: "Phone number is required",
    Label: "Le numéro de téléphone est obligatoire",
  },
  {
    Index: "650",
    Default: "Phone number verified",
    Label: "Numéro de téléphone vérifié",
  },
  {
    Index: "651",
    Default: "Phone verification",
    Label: "Vérification téléphonique",
  },
  {
    Index: "652",
    Default: "Phone verification by SMS",
    Label: "Vérification téléphonique par SMS",
  },
  {
    Index: "653",
    Default: "Please confirm your PIN!",
    Label: "Veuillez confirmer votre code PIN !",
  },
  {
    Index: "654",
    Default: "Please confirm your password!",
    Label: "Veuillez confirmer votre mot de passe !",
  },
  {
    Index: "655",
    Default: "Please enter a 6-digit OTP",
    Label: "Veuillez entrer un code OTP à 6 chiffres",
  },
  {
    Index: "656",
    Default: "Please enter account number",
    Label: "Veuillez entrer le numéro de compte",
  },
  {
    Index: "657",
    Default: "Please enter amount",
    Label: "Veuillez entrer le montant",
  },
  {
    Index: "658",
    Default: "Please enter first name",
    Label: "Veuillez entrer le prénom",
  },
  {
    Index: "659",
    Default: "Please enter last name",
    Label: "Veuillez entrer le nom",
  },
  {
    Index: "660",
    Default: "Please enter phone number",
    Label: "Veuillez entrer le numéro de téléphone",
  },
  {
    Index: "661",
    Default: "Please enter your password to continue.",
    Label: "Veuillez entrer votre mot de passe pour continuer.",
  },
  {
    Index: "662",
    Default: "Please enter your username",
    Label: "Veuillez entrer votre nom d'utilisateur",
  },
  {
    Index: "663",
    Default: "Please fill in all required fields",
    Label: "Veuillez remplir tous les champs obligatoires",
  },
  {
    Index: "664",
    Default: "Please input your Date of birth",
    Label: "Veuillez saisir votre date de naissance",
  },
  {
    Index: "665",
    Default: "Please input your PIN",
    Label: "Veuillez saisir votre code PIN",
  },
  {
    Index: "666",
    Default: "Please input your birth date",
    Label: "Veuillez saisir votre date de naissance",
  },
  {
    Index: "667",
    Default: "Please input your email",
    Label: "Veuillez saisir votre e-mail",
  },
  {
    Index: "668",
    Default: "Please input your first name",
    Label: "Veuillez saisir votre prénom",
  },
  {
    Index: "669",
    Default: "Please input your new PIN!",
    Label: "Veuillez saisir votre nouveau code PIN !",
  },
  {
    Index: "670",
    Default: "Please input your password!",
    Label: "Veuillez saisir votre mot de passe !",
  },
  {
    Index: "671",
    Default: "Please input your phone number",
    Label: "Veuillez saisir votre numéro de téléphone",
  },
  {
    Index: "672",
    Default: "Please input your user name",
    Label: "Veuillez saisir votre nom d'utilisateur",
  },
  {
    Index: "673",
    Default: "Please input your username",
    Label: "Veuillez saisir votre nom d'utilisateur",
  },
  {
    Index: "674",
    Default: "Please select an operator",
    Label: "Veuillez sélectionner un opérateur",
  },
  {
    Index: "675",
    Default: "Please select currency",
    Label: "Veuillez sélectionner la devise",
  },
  {
    Index: "676",
    Default: "Please upload",
    Label: "Veuillez télécharger",
  },
  {
    Index: "677",
    Default: "Please verify your phone number to continue",
    Label: "Veuillez vérifier votre numéro de téléphone pour continuer",
  },
  {
    Index: "678",
    Default: "Print",
    Label: "Imprimer",
  },
  {
    Index: "679",
    Default: "Print Transactions",
    Label: "Imprimer les transactions",
  },
  {
    Index: "680",
    Default: "Privacy",
    Label: "Confidentialité",
  },
  {
    Index: "681",
    Default: "Process in Batches",
    Label: "Traiter par lots",
  },
  {
    Index: "682",
    Default: "Processing batch",
    Label: "Traitement du lot",
  },
  {
    Index: "683",
    Default: "Processing paused",
    Label: "Traitement suspendu",
  },
  {
    Index: "684",
    Default: "Processing...",
    Label: "Traitement en cours...",
  },
  {
    Index: "685",
    Default: "Profession",
    Label: "Profession",
  },
  {
    Index: "686",
    Default: "Provider",
    Label: "Fournisseur",
  },
  {
    Index: "687",
    Default: "Real-time tracking",
    Label: "Suivi en temps réel",
  },
  {
    Index: "688",
    Default: "Reason",
    Label: "Motif",
  },
  {
    Index: "689",
    Default: "Recipient",
    Label: "Bénéficiaire",
  },
  {
    Index: "690",
    Default: "Recipient added successfully",
    Label: "Bénéficiaire ajouté avec succès",
  },
  {
    Index: "691",
    Default: "Recipient updated successfully",
    Label: "Bénéficiaire mis à jour avec succès",
  },
  {
    Index: "692",
    Default: "Recipients",
    Label: "Bénéficiaires",
  },
  {
    Index: "693",
    Default: "Register",
    Label: "S'inscrire",
  },
  {
    Index: "694",
    Default: "Register now",
    Label: "S'inscrire maintenant",
  },
  {
    Index: "695",
    Default: "Remind me later",
    Label: "Me le rappeler plus tard",
  },
  {
    Index: "696",
    Default: "Remove Beneficiary",
    Label: "Supprimer le bénéficiaire",
  },
  {
    Index: "697",
    Default: "Repay now",
    Label: "Rembourser maintenant",
  },
  {
    Index: "698",
    Default: "Request a loan",
    Label: "Demander un prêt",
  },
  {
    Index: "699",
    Default: "Required",
    Label: "Requis",
  },
  {
    Index: "700",
    Default: "Resend a new code",
    Label: "Renvoyer un nouveau code",
  },
  {
    Index: "701",
    Default: "Resend in",
    Label: "Renvoyer dans",
  },
  {
    Index: "702",
    Default: "Reset",
    Label: "Réinitialiser",
  },
  {
    Index: "703",
    Default: "Retake",
    Label: "Reprendre",
  },
  {
    Index: "704",
    Default: "Review",
    Label: "Examiner",
  },
  {
    Index: "705",
    Default: "Review and submit",
    Label: "Vérifier et soumettre",
  },
  {
    Index: "706",
    Default: "Run Count",
    Label: "Nombre d'exécutions",
  },
  {
    Index: "707",
    Default: "Save",
    Label: "Enregistrer",
  },
  {
    Index: "708",
    Default: "Save All",
    Label: "Tout enregistrer",
  },
  {
    Index: "709",
    Default: "Save Bank Account",
    Label: "Enregistrer le compte bancaire",
  },
  {
    Index: "710",
    Default: "Save Phone Number",
    Label: "Enregistrer le numéro de téléphone",
  },
  {
    Index: "711",
    Default: "Savings accounts",
    Label: "Comptes d'épargne",
  },
  {
    Index: "712",
    Default: "Search user",
    Label: "Rechercher un utilisateur",
  },
  {
    Index: "713",
    Default: "Searching...",
    Label: "Recherche en cours...",
  },
  {
    Index: "714",
    Default: "Secure connection",
    Label: "Connexion sécurisée",
  },
  {
    Index: "715",
    Default: "Secure digital banking",
    Label: "Services bancaires numériques sécurisés",
  },
  {
    Index: "716",
    Default: "Security Code",
    Label: "Code de sécurité",
  },
  {
    Index: "717",
    Default: "Security Verification",
    Label: "Vérification de sécurité",
  },
  {
    Index: "718",
    Default: "Select XLSX File",
    Label: "Sélectionner le fichier XLSX",
  },
  {
    Index: "719",
    Default: "Select a Pay Bills Category",
    Label: "Sélectionner une catégorie de factures",
  },
  {
    Index: "720",
    Default: "Select a recipient",
    Label: "Sélectionner un bénéficiaire",
  },
  {
    Index: "721",
    Default: "Select account number",
    Label: "Sélectionner le numéro de compte",
  },
  {
    Index: "722",
    Default: "Select account type",
    Label: "Sélectionner le type de compte",
  },
  {
    Index: "723",
    Default: "Select an option",
    Label: "Sélectionner une option",
  },
  {
    Index: "724",
    Default: "Select currency",
    Label: "Sélectionner la devise",
  },
  {
    Index: "725",
    Default: "Select destination country",
    Label: "Sélectionner le pays de destination",
  },
  {
    Index: "726",
    Default: "Select document type",
    Label: "Sélectionner le type de document",
  },
  {
    Index: "727",
    Default: "Select gender",
    Label: "Sélectionner le genre",
  },
  {
    Index: "728",
    Default: "Select marital status",
    Label: "Sélectionner l'état civil",
  },
  {
    Index: "729",
    Default: "Select profession",
    Label: "Sélectionner la profession",
  },
  {
    Index: "730",
    Default: "Select title",
    Label: "Sélectionner la civilité",
  },
  {
    Index: "731",
    Default: "Select your country",
    Label: "Sélectionnez votre pays",
  },
  {
    Index: "732",
    Default: "Selfie Verification",
    Label: "Vérification par selfie",
  },
  {
    Index: "733",
    Default: "Selfie uploaded, OTP required",
    Label: "Selfie téléchargé, OTP requis",
  },
  {
    Index: "734",
    Default: "Send",
    Label: "Envoyer",
  },
  {
    Index: "735",
    Default: "Send cash",
    Label: "Envoyer de l'argent liquide",
  },
  {
    Index: "736",
    Default: "Send code",
    Label: "Envoyer le code",
  },
  {
    Index: "737",
    Default: "Send voucher",
    Label: "Envoyer un bon",
  },
  {
    Index: "738",
    Default: "Send voucher ?",
    Label: "Envoyer un bon d'achat ?",
  },
  {
    Index: "739",
    Default: "Service Fees",
    Label: "Frais de service",
  },
  {
    Index: "740",
    Default: "Sign in to your account",
    Label: "Connectez-vous à votre compte",
  },
  {
    Index: "741",
    Default: "Sign up",
    Label: "S'inscrire",
  },
  {
    Index: "742",
    Default: "Simple savings account",
    Label: "Compte d'épargne simple",
  },
  {
    Index: "743",
    Default: "Step 1 of 2",
    Label: "Étape 1 sur 2",
  },
  {
    Index: "744",
    Default: "Step 2 of 2",
    Label: "Étape 2 sur 2",
  },
  {
    Index: "745",
    Default: "Sub Organizations Management",
    Label: "Gestion des sous-organisations",
  },
  {
    Index: "746",
    Default: "Submit application",
    Label: "Soumettre la demande",
  },
  {
    Index: "747",
    Default: "Submitted",
    Label: "Soumis",
  },
  {
    Index: "748",
    Default: "Sufficient Balance",
    Label: "Solde suffisant",
  },
  {
    Index: "749",
    Default: "TRANSACTION DETAILS",
    Label: "DÉTAILS DE LA TRANSACTION",
  },
  {
    Index: "750",
    Default: "Take Selfie",
    Label: "Prendre un selfie",
  },
  {
    Index: "751",
    Default: "Take a clear photo of yourself",
    Label: "Prenez une photo claire de vous-même",
  },
  {
    Index: "752",
    Default: "Takes about 5 minutes",
    Label: "Prend environ 5 minutes",
  },
  {
    Index: "753",
    Default: "Taxes",
    Label: "Taxes",
  },
  {
    Index: "754",
    Default: "Tel",
    Label: "Tél",
  },
  {
    Index: "755",
    Default: "Telephone",
    Label: "Téléphone",
  },
  {
    Index: "756",
    Default: "Tell us about yourself",
    Label: "Parlez-nous de vous",
  },
  {
    Index: "757",
    Default: "Terms",
    Label: "Conditions",
  },
  {
    Index: "758",
    Default: "Terms and Conditions",
    Label: "Conditions générales",
  },
  {
    Index: "759",
    Default: "The Passwords do not match.",
    Label: "Les mots de passe ne correspondent pas.",
  },
  {
    Index: "760",
    Default: "The password must be at least ",
    Label: "Le mot de passe doit comporter au moins ",
  },
  {
    Index: "761",
    Default: "The two PINs do not match!",
    Label: "Les deux codes PIN ne correspondent pas !",
  },
  {
    Index: "762",
    Default: "This login requires OTP verification",
    Label: "Cette connexion nécessite une vérification OTP",
  },
  {
    Index: "763",
    Default: "This login requires selfie verification",
    Label: "Cette connexion nécessite une vérification par selfie",
  },
  {
    Index: "764",
    Default: "Title",
    Label: "Titre",
  },
  {
    Index: "765",
    Default: "To confirm, type",
    Label: "Pour confirmer, tapez",
  },
  {
    Index: "766",
    Default: "Total",
    Label: "Total",
  },
  {
    Index: "767",
    Default: "Total Amount",
    Label: "Montant total",
  },
  {
    Index: "768",
    Default: "Total Recipients",
    Label: "Total des bénéficiaires",
  },
  {
    Index: "769",
    Default: "Track application",
    Label: "Suivre la demande",
  },
  {
    Index: "770",
    Default: "Track your application",
    Label: "Suivez votre demande",
  },
  {
    Index: "771",
    Default: "Transaction status",
    Label: "Statut de la transaction",
  },
  {
    Index: "772",
    Default: "Transfer Number",
    Label: "Numéro de transfert",
  },
  {
    Index: "773",
    Default: "Transfer from",
    Label: "Transférer depuis",
  },
  {
    Index: "774",
    Default: "Transfer money",
    Label: "Transférer de l'argent",
  },
  {
    Index: "775",
    Default: "Type your username",
    Label: "Tapez votre nom d'utilisateur",
  },
  {
    Index: "776",
    Default: "Under review",
    Label: "En cours d'examen",
  },
  {
    Index: "777",
    Default: "Update",
    Label: "Mettre à jour",
  },
  {
    Index: "778",
    Default: "Update Beneficiary",
    Label: "Mettre à jour le bénéficiaire",
  },
  {
    Index: "779",
    Default: "Upload",
    Label: "Télécharger",
  },
  {
    Index: "780",
    Default: "Upload Image",
    Label: "Télécharger une image",
  },
  {
    Index: "781",
    Default: "Upload error!",
    Label: "Erreur de téléchargement !",
  },
  {
    Index: "782",
    Default: "Upload failed!",
    Label: "Le téléchargement a échoué !",
  },
  {
    Index: "783",
    Default: "Upload process cancelled",
    Label: "Processus de téléchargement annulé",
  },
  {
    Index: "784",
    Default: "Upload your documents",
    Label: "Téléchargez vos documents",
  },
  {
    Index: "785",
    Default: "User",
    Label: "Utilisateur",
  },
  {
    Index: "786",
    Default: "User Permissions Management",
    Label: "Gestion des permissions utilisateurs",
  },
  {
    Index: "787",
    Default: "Username",
    Label: "Nom d'utilisateur",
  },
  {
    Index: "788",
    Default: "Username or Phone number",
    Label: "Nom d'utilisateur ou numéro de téléphone",
  },
  {
    Index: "789",
    Default: "Validating",
    Label: "Validation en cours",
  },
  {
    Index: "790",
    Default: "Validation failed",
    Label: "La validation a échoué",
  },
  {
    Index: "791",
    Default: "Verification number",
    Label: "Numéro de vérification",
  },
  {
    Index: "792",
    Default: "Verify",
    Label: "Vérifier",
  },
  {
    Index: "793",
    Default: "Verify Authentication Code",
    Label: "Vérifier le code d'authentification",
  },
  {
    Index: "794",
    Default: "Verify your phone number",
    Label: "Vérifiez votre numéro de téléphone",
  },
  {
    Index: "795",
    Default: "View",
    Label: "Voir",
  },
  {
    Index: "796",
    Default: "View Transactions",
    Label: "Voir les transactions",
  },
  {
    Index: "797",
    Default: "Wallet",
    Label: "Portefeuille",
  },
  {
    Index: "798",
    Default: "Wallet Balance",
    Label: "Solde du portefeuille",
  },
  {
    Index: "799",
    Default: "Wallet Information",
    Label: "Informations du portefeuille",
  },
  {
    Index: "800",
    Default: "Warning: This action cannot be undone",
    Label: "Attention : Cette action est irréversible",
  },
  {
    Index: "801",
    Default: "We could not validate your information",
    Label: "Nous n'avons pas pu valider vos informations",
  },
  {
    Index: "802",
    Default: "We keep your account and transactions safe",
    Label: "Nous protégeons votre compte et vos transactions",
  },
  {
    Index: "803",
    Default: "Welcome to Digital Banking",
    Label: "Bienvenue sur votre banque en ligne",
  },
  {
    Index: "804",
    Default: "What to expect",
    Label: "À quoi vous attendre",
  },
  {
    Index: "805",
    Default: "Withdraw",
    Label: "Retirer",
  },
  {
    Index: "806",
    Default: "Withdraw money",
    Label: "Retirer de l'argent",
  },
  {
    Index: "807",
    Default: "Yes",
    Label: "Oui",
  },
  {
    Index: "808",
    Default: "You are not eligible yet",
    Label: "Vous n'êtes pas encore éligible",
  },
  {
    Index: "809",
    Default: "You can continue to the next step.",
    Label: "Vous pouvez passer à l'étape suivante.",
  },
  {
    Index: "810",
    Default: "You can only upload JPG/PNG files!",
    Label: "Vous pouvez uniquement télécharger des fichiers JPG/PNG !",
  },
  {
    Index: "811",
    Default: "You can only upload XLSX files!",
    Label: "Vous pouvez uniquement télécharger des fichiers XLSX !",
  },
  {
    Index: "812",
    Default: "You can only upload image files!",
    Label: "Vous pouvez uniquement télécharger des fichiers d'image !",
  },
  {
    Index: "813",
    Default: "You have unsaved changes",
    Label: "Vous avez des modifications non enregistrées",
  },
  {
    Index: "814",
    Default: "Your AGB account, opened from anywhere.",
    Label: "Votre compte AGB, ouvert depuis n'importe où.",
  },
  {
    Index: "815",
    Default: "Your PIN numbers do not match.",
    Label: "Vos codes PIN ne correspondent pas.",
  },
  {
    Index: "816",
    Default: "Your account is open",
    Label: "Votre compte est ouvert",
  },
  {
    Index: "817",
    Default: "Your account number",
    Label: "Votre numéro de compte",
  },
  {
    Index: "818",
    Default: "Your account numbers",
    Label: "Vos numéros de compte",
  },
  {
    Index: "819",
    Default: "Your application has been received",
    Label: "Votre demande a été reçue",
  },
  {
    Index: "820",
    Default: "Your application is still being processed",
    Label: "Votre demande est toujours en cours de traitement",
  },
  {
    Index: "821",
    Default: "Your application was not approved",
    Label: "Votre demande n'a pas été approuvée",
  },
  {
    Index: "822",
    Default: "Your identity details",
    Label: "Vos données d'identité",
  },
  {
    Index: "823",
    Default: "a ",
    Label: "un ",
  },
  {
    Index: "824",
    Default: "and at least one ",
    Label: "et au moins un ",
  },
  {
    Index: "825",
    Default: "below",
    Label: "ci-dessous",
  },
  {
    Index: "826",
    Default: "containing an ",
    Label: "contenant une ",
  },
  {
    Index: "827",
    Default: "digit",
    Label: "chiffre",
  },
  {
    Index: "828",
    Default: "lowercase",
    Label: "minuscule",
  },
  {
    Index: "829",
    Default: "name@example.com",
    Label: "nom@exemple.com",
  },
  {
    Index: "830",
    Default: "organizations",
    Label: "organisations",
  },
  {
    Index: "831",
    Default: "recipients processed successfully",
    Label: "bénéficiaires traités avec succès",
  },
  {
    Index: "832",
    Default: "recipients saved successfully",
    Label: "bénéficiaires enregistrés avec succès",
  },
  {
    Index: "833",
    Default: "rows",
    Label: "lignes",
  },
  {
    Index: "834",
    Default: "special character",
    Label: "caractère spécial",
  },
  {
    Index: "835",
    Default: "to confirm",
    Label: "pour confirmer",
  },
  {
    Index: "836",
    Default: "uppercase",
    Label: "majuscule",
  },
  {
    Index: "837",
    Default: "users",
    Label: "utilisateurs",
  },
  {
    Index: "838",
    Default: "users found",
    Label: "utilisateurs trouvés",
  },
  {
    Index: "839",
    Default: "Account number, username, or phone number",
    Label: "Numéro de compte, nom d'utilisateur ou téléphone",
  },
  {
    Index: "840",
    Default: "You don't have any beneficiaries yet",
    Label: "Vous n'avez pas encore de bénéficiaires",
  },
  {
    Index: "841",
    Default: "transaction history",
    Label: "Historique des transactions",
  },
  {
    Index: "842",
    Default: "Microloans",
    Label: "Microcrédits",
  },
  {
    Index: "843",
    Default: "Savings",
    Label: "Épargne",
  },
  {
    Index: "844",
    Default: "Companion cards",
    Label: "Cartes associées",
  },
  {
    Index: "845",
    Default: "My organization",
    Label: "Mon organisation",
  },
  {
    Index: "846",
    Default: "My Contacts",
    Label: "Mes contacts",
  },
  {
    Index: "847",
    Default: "Services",
    Label: "Services",
  },
  {
    Index: "848",
    Default: "Customer support",
    Label: "Service client",
  },
  {
    Index: "849",
    Default: "My Profile",
    Label: "Mon profil",
  },
  {
    Index: "850",
    Default: "Payments",
    Label: "Paiements",
  },
  {
    Index: "851",
    Default: "Notification",
    Label: "Notification",
  },
  {
    Index: "852",
    Default: "Money Transfer",
    Label: "Transfert d'argent",
  },
  {
    Index: "853",
    Default: "Paybills",
    Label: "Paiement de factures",
  },
  {
    Index: "854",
    Default: "Your account is not registered as an organization account",
    Label: "Votre compte n'est pas enregistré en tant que compte d'organisation",
  },
  {
    Index: "855",
    Default: "It looks like your account is set up as an individual account, not an organization account. Some features are only available to organization accounts",
    Label: "Il semble que votre compte soit configuré comme un compte individuel et non d'organisation. Certaines fonctionnalités ne sont disponibles que pour les organisations.",
  },
  {
    Index: "856",
    Default: "If you need access, check your account type or reach out to your system administrator to update it",
    Label: "Si vous avez besoin d'un accès, vérifiez le type de votre compte ou contactez votre administrateur pour le mettre à jour.",
  },
  {
    Index: '389',
    Default: 'Activate your account',
    Label: 'Activez votre compte',
  },
  {
    Index: '390',
    Default: 'Upload your identity documents so we can verify you and open your account.',
    Label: "Téléversez vos pièces d'identité afin que nous puissions vous vérifier et ouvrir votre compte.",
  },
  {
    Index: '391',
    Default: 'Required documents',
    Label: 'Documents requis',
  },
  {
    Index: '392',
    Default: 'Encrypted and only seen by the AGB verification team.',
    Label: "Chiffrés et consultés uniquement par l'équipe de vérification AGB.",
  },
  {
    Index: '393',
    Default: 'Documents received',
    Label: 'Documents reçus',
  },
  {
    Index: '394',
    Default: 'Thank you. Our team is reviewing your documents and will activate your account shortly. We will let you know by email.',
    Label: 'Merci. Notre équipe examine vos documents et activera votre compte sous peu. Nous vous informerons par e-mail.',
  },
  {
    Index: '395',
    Default: 'Continue to my account',
    Label: 'Accéder à mon compte',
  },
  {
    Index: '396',
    Default: 'ID document (front)',
    Label: "Pièce d'identité (recto)",
  },
  {
    Index: '397',
    Default: 'ID document (back)',
    Label: "Pièce d'identité (verso)",
  },
  {
    Index: '398',
    Default: 'Photo of you',
    Label: 'Votre photo',
  },
  {
    Index: '399',
    Default: 'Proof of address',
    Label: 'Justificatif de domicile',
  },
  {
    Index: '400',
    Default: 'The side with your photo',
    Label: 'La face avec votre photo',
  },
  {
    Index: '401',
    Default: 'The reverse side of the same document',
    Label: 'Le verso du même document',
  },
  {
    Index: '402',
    Default: 'A live selfie, no hat or sunglasses',
    Label: 'Une photo nette de votre visage, sans chapeau ni lunettes de soleil',
  },
  {
    Index: '403',
    Default: 'A recent utility bill or bank statement',
    Label: 'Une facture récente ou un relevé bancaire',
  },
  {
    Index: '404',
    Default: 'Optional',
    Label: 'Facultatif',
  },
  {
    Index: '405',
    Default: 'Upload failed. Please try again.',
    Label: 'Échec du téléversement. Veuillez réessayer.',
  },
  {
    Index: '406',
    Default: 'Received',
    Label: 'Reçu',
  },
  {
    Index: '407',
    Default: 'Replace',
    Label: 'Remplacer',
  },
  {
    Index: '408',
    Default: 'Retry',
    Label: 'Réessayer',
  },
  {
    Index: '409',
    Default: 'Pending verification',
    Label: 'Vérification en attente',
  },
  {
    Index: '410',
    Default: 'File is too large. Max size:',
    Label: 'Fichier trop volumineux. Taille max :',
  },
  {
    Index: '411',
    Default: 'Finish verification',
    Label: 'Terminer la vérification',
  },
  {
    Index: '412',
    Default: 'documents',
    Label: 'documents',
  },
  {
    Index: '413',
    Default: 'Verify your identity',
    Label: 'Vérifiez votre identité',
  },
  {
    Index: '414',
    Default: 'A few photos and your account is ready to use.',
    Label: 'Quelques photos et votre compte est prêt.',
  },
  {
    Index: '415',
    Default: 'required',
    Label: 'requis',
  },
  {
    Index: '416',
    Default: 'Encrypted. Only the AGB team sees it.',
    Label: "Chiffré. Seule l'équipe AGB y a accès.",
  },
  {
    Index: '417',
    Default: 'Drag your photo here',
    Label: 'Glissez votre photo ici',
  },
  {
    Index: '418',
    Default: 'or',
    Label: 'ou',
  },
  {
    Index: '419',
    Default: 'browse your files',
    Label: 'parcourez vos fichiers',
  },
  {
    Index: '420',
    Default: 'up to',
    Label: "jusqu'à",
  },
  {
    Index: '421',
    Default: 'Uploading securely...',
    Label: 'Envoi sécurisé...',
  },
  {
    Index: '422',
    Default: 'Choose another',
    Label: 'Choisir une autre',
  },
  {
    Index: '423',
    Default: 'Try again',
    Label: 'Réessayer',
  },
  {
    Index: '424',
    Default: 'Use this photo',
    Label: 'Utiliser cette photo',
  },
  {
    Index: '425',
    Default: 'Take a photo',
    Label: 'Prendre une photo',
  },
  {
    Index: '426',
    Default: 'Previous',
    Label: 'Précédent',
  },
  {
    Index: '427',
    Default: 'Step',
    Label: 'Étape',
  },
  {
    Index: '428',
    Default: 'Finish',
    Label: 'Terminer',
  },
  {
    Index: '429',
    Default: 'You are verified',
    Label: 'Vous êtes vérifié',
  },
  {
    Index: '430',
    Default: 'Thank you. Your identity is confirmed and your account is fully active.',
    Label: 'Merci. Votre identité est confirmée et votre compte est entièrement actif.',
  },
  {
    Index: '431',
    Default: 'Please choose a PNG or JPG image.',
    Label: 'Veuillez choisir une image PNG ou JPG.',
  },
  {
    Index: '432',
    Default: 'All four corners visible',
    Label: 'Les quatre coins visibles',
  },
  {
    Index: '433',
    Default: 'No glare or blur',
    Label: 'Sans reflet ni flou',
  },
  {
    Index: '434',
    Default: 'Text is readable',
    Label: 'Texte lisible',
  },
  {
    Index: '435',
    Default: 'Same document as the front',
    Label: 'Même document que le recto',
  },
  {
    Index: '436',
    Default: 'Face the camera, eyes open',
    Label: 'Face à la caméra, yeux ouverts',
  },
  {
    Index: '437',
    Default: 'Good, even light',
    Label: 'Bon éclairage uniforme',
  },
  {
    Index: '438',
    Default: 'Plain background',
    Label: 'Fond uni',
  },
  {
    Index: '439',
    Default: 'Less than 3 months old',
    Label: 'Moins de 3 mois',
  },
  {
    Index: '440',
    Default: 'Shows your name and address',
    Label: 'Indique votre nom et adresse',
  },
  {
    Index: '441',
    Default: 'Whole page visible',
    Label: 'Page entière visible',
  },
  {
    Index: '442',
    Default: 'Click to zoom',
    Label: 'Cliquez pour agrandir',
  },
  {
    Index: '443',
    Default: 'document left',
    Label: 'document restant',
  },
  {
    Index: '444',
    Default: 'documents left',
    Label: 'documents restants',
  },
  {
    Index: '445',
    Default: 'Unlocks once your account is opened',
    Label: "Disponible dès l'ouverture de votre compte",
  },
  {
    Index: '446',
    Default: 'Your details are with AGB',
    Label: 'Vos informations sont chez AGB',
  },
  {
    Index: '447',
    Default: 'Identity documents',
    Label: "Pièces d'identité",
  },
  {
    Index: '448',
    Default: 'received',
    Label: 'reçus',
  },
  {
    Index: '449',
    Default: 'Checking...',
    Label: 'Vérification...',
  },
  {
    Index: '450',
    Default: 'Bank review',
    Label: 'Examen par la banque',
  },
  {
    Index: '451',
    Default: 'AGB is reviewing your application',
    Label: 'AGB examine votre demande',
  },
  {
    Index: '452',
    Default: 'Starts once your documents are in',
    Label: 'Commence dès réception de vos documents',
  },
  {
    Index: '453',
    Default: 'Account ready',
    Label: 'Compte prêt',
  },
  {
    Index: '454',
    Default: 'Everything unlocks automatically',
    Label: 'Tout se débloque automatiquement',
  },
  {
    Index: '455',
    Default: 'In progress',
    Label: 'En cours',
  },
  {
    Index: '456',
    Default: 'Your account is being opened',
    Label: 'Votre compte est en cours d’ouverture',
  },
  {
    Index: '457',
    Default: 'All set on your side. We will email you as soon as your account is open.',
    Label: 'Tout est prêt de votre côté. Nous vous écrirons dès que votre compte sera ouvert.',
  },
  {
    Index: '458',
    Default: 'One step left on your side: send your identity documents so AGB can review your application.',
    Label: "Il vous reste une étape : envoyez vos pièces d'identité pour qu'AGB examine votre demande.",
  },
  {
    Index: '459',
    Default: 'Continue verification',
    Label: 'Continuer la vérification',
  },
  {
    Index: '460',
    Default: 'While you wait',
    Label: 'En attendant',
  },
  {
    Index: '461',
    Default: 'Complete your profile',
    Label: 'Complétez votre profil',
  },
  {
    Index: '462',
    Default: 'Check your personal details',
    Label: 'Vérifiez vos informations personnelles',
  },
  {
    Index: '463',
    Default: 'Call AGB support',
    Label: 'Appeler le support AGB',
  },
  {
    Index: '464',
    Default: 'Email support',
    Label: 'Écrire au support',
  },
  {
    Index: '465',
    Default: 'Unlocks with your account',
    Label: 'Disponible avec votre compte',
  },
  {
    Index: '466',
    Default: 'Transfers',
    Label: 'Transferts',
  },
  {
    Index: '467',
    Default: 'Pay bills',
    Label: 'Payer des factures',
  },
  {
    Index: '468',
    Default: 'Statements',
    Label: 'Relevés',
  },
  {
    Index: '469',
    Default: 'These open automatically the moment AGB opens your account. Nothing else to do.',
    Label: "Ils s'activent automatiquement dès qu'AGB ouvre votre compte. Rien d'autre à faire.",
  },
  {
    Index: '470',
    Default: 'Available once your account is opened',
    Label: "Disponible dès l'ouverture de votre compte",
  },
  {
    Index: '471',
    Default: 'This part of G-Banking needs an open AGB account. It unlocks automatically as soon as AGB opens yours.',
    Label: "Cette partie de G-Banking nécessite un compte AGB ouvert. Elle se débloque automatiquement dès qu'AGB ouvre le vôtre.",
  },
  {
    Index: '472',
    Default: 'See my application',
    Label: 'Voir ma demande',
  },
  {
    Index: '473',
    Default: 'Good morning',
    Label: 'Bonjour',
  },
  {
    Index: '474',
    Default: 'Good afternoon',
    Label: 'Bon après-midi',
  },
  {
    Index: '475',
    Default: 'Good evening',
    Label: 'Bonsoir',
  },
  {
    Index: '476',
    Default: 'Your AGB account is being opened.',
    Label: "Votre compte AGB est en cours d'ouverture.",
  },
  {
    Index: '477',
    Default: 'Your next step',
    Label: 'Votre prochaine étape',
  },
  {
    Index: '478',
    Default: 'Nothing to do, we are on it',
    Label: "Rien à faire, on s'en occupe",
  },
  {
    Index: '479',
    Default: 'Send your identity documents so AGB can review your application.',
    Label: "Envoyez vos pièces d'identité pour qu'AGB examine votre demande.",
  },
  {
    Index: '480',
    Default: 'Coming with your account',
    Label: 'Avec votre compte',
  },
  {
    Index: '481',
    Default: 'Your profile',
    Label: 'Votre profil',
  },
  {
    Index: '482',
    Default: 'Application progress',
    Label: 'Avancement de la demande',
  },
  {
    Index: '483',
    Default: 'Retake',
    Label: 'Reprendre',
  },
  {
    Index: '484',
    Default: 'Retake selfie',
    Label: 'Reprendre le selfie',
  },
  {
    Index: '485',
    Default: 'Open camera',
    Label: 'Ouvrir la caméra',
  },
  {
    Index: '486',
    Default: 'Capture',
    Label: 'Prendre la photo',
  },
  {
    Index: '487',
    Default: 'Take a selfie',
    Label: 'Prenez un selfie',
  },
  {
    Index: '488',
    Default: 'Camera access is blocked',
    Label: "L'accès à la caméra est bloqué",
  },
  {
    Index: '489',
    Default: 'Allow camera access in your browser settings, then try again.',
    Label: "Autorisez l'accès à la caméra dans les paramètres de votre navigateur, puis réessayez.",
  },
  {
    Index: '490',
    Default: 'No camera available',
    Label: 'Aucune caméra disponible',
  },
  {
    Index: '491',
    Default: 'Use a device with a camera to take your selfie.',
    Label: "Utilisez un appareil doté d'une caméra pour prendre votre selfie.",
  },
  {
    Index: '492',
    Default: 'We will compare it with the photo on your ID. It is taken live, not uploaded.',
    Label: "Nous le comparerons avec la photo de votre pièce d'identité. Il est pris en direct, pas importé.",
  },
];



